<template>
  <div
    class="d-flex pa-2 flex-column"
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'min-content',
    }"
  >
    <div class="d-flex pa-5 flex-column">
      <h3>{{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }} Detail</h3>
      <p>
        Informasi detail mengenai
        {{ merchantTypeId == '1' ? 'merchant' : 'sub merchant' }}
      </p>
    </div>

    <div v-if="loading" class="d-flex pa-5 flex-column">
      <v-progress-linear
        top
        v-if="loading"
        :active="loading"
        :indeterminate="loading"
        color="red lighten-2"
      />
    </div>
    <v-card
      v-if="!loading"
      class="d-flex pa-2 flex-column"
      :style="{ margin: '0px 20px 40px 20px' }"
      elevation="2"
    >
      <div
        v-if="
          data != null &&
          data.aggregator_name != null &&
          data.aggregator_name != ''
        "
      >
        <v-card :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }">
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3>Aggregator</h3>
          </div>
        </v-card>
        <div :style="{ padding: '20px 30px 20px 30px' }" v-if="!loading">
          <v-row>
            <v-col cols="10" sm="4"> Nama Aggregator </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ data == null ? '' : data.aggregator_name }}
            </v-col>
          </v-row>
        </div>
      </div>
      <v-card
        class="mb-12"
        height="20px"
        :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3 class="mb-5">
            Data {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
          </h3>
        </div>
      </v-card>
      <div :style="{ padding: '20px 30px 20px 30px' }" v-if="!loading">
        <div v-if="isEdit && isUpdatePTEN">
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              Nama {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
            </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="merchantName"
                ref="merchantName"
                v-model="merchantName"
                @change="$v.merchantName.$touch()"
                @blur="$v.merchantName.$touch()"
                :error-messages="merchantNameErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> NMID </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="nmid"
                ref="nmid"
                v-model="nmid"
                @change="$v.nmid.$touch()"
                @blur="$v.nmid.$touch()"
                :error-messages="nmidErrors"
                :filled="!isAdd"
                :readonly="!isAdd"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> MPAN </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="mpan"
                ref="mpan"
                v-model="mpan"
                @change="$v.mpan.$touch()"
                @blur="$v.mpan.$touch()"
                :error-messages="mpanErrors"
                :filled="!isAdd"
                :readonly="!isAdd"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> MID </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="mid"
                ref="mid"
                v-model="mid"
                @change="$v.mid.$touch()"
                @blur="$v.mid.$touch()"
                :error-messages="midErrors"
                :filled="!isAdd"
                :readonly="!isAdd"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Nomor KTP Pemilik Usaha </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="noKTP"
                ref="noKTP"
                v-model="noKTP"
                :counter="16"
                @change="$v.noKTP.$touch()"
                @blur="$v.noKTP.$touch()"
                :error-messages="noKTPErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              Nomor NPWP
              {{ accountType == '2' ? 'Perusahaan' : 'Pemilik Usaha' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="noNPWP"
                ref="noNPWP"
                v-model="noNPWP"
                :append-icon="!isCorporate ? 'mdi-orbit-variant' : ''"
                :suffix="!isCorporate ? 'Samakan dengan No KTP' : ''"
                :counter="16"
                @click:append="copyNoKTPtoNPWP"
                @change="$v.noNPWP.$touch()"
                @blur="$v.noNPWP.$touch()"
                :error-messages="noNPWPErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              Tipe
              {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-select
                id="accountTypeField"
                ref="accountTypeField"
                :items="listAccountType"
                item-text="text"
                item-value="value"
                v-model="accountTypeField"
                @change="$v.accountTypeField.$touch()"
                @blur="$v.accountTypeField.$touch()"
                :error-messages="accountTypeFieldErrors"
                filled
                readonly
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Tipe QR</v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-select
                id="qrType"
                ref="qrType"
                :items="isFromAggregator ? qrItemsFiltered : qrItems"
                item-text="text"
                item-value="value"
                v-model="qrType"
                @change="$v.qrType.$touch()"
                @blur="$v.qrType.$touch()"
                :error-messages="qrTypeErrors"
                filled
                readonly
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">Jenis Usaha</v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="jenisUsaha"
                ref="jenisUsaha"
                clearable
                v-model="jenisUsaha"
                :items="itemsJenisUsaha"
                item-text="mcc_name"
                return-object
                :filter="customFilter"
                :error-messages="jenisUsahaErrors"
                @change="$v.jenisUsaha.$touch()"
                @blur="$v.jenisUsaha.$touch()"
                :loading="isLoadingJenisUsaha"
                hide-selected
                single-line
              >
                <template v-slot:item="data">
                  <template v-if="typeof data.item != 'object'">
                    <v-list-item-content>{{ data.item }}</v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title
                        >{{ data.item.mcc }} -
                        {{ data.item.mcc_name }}</v-list-item-title
                      >
                    </v-list-item-content>
                  </template>
                </template>
                <template v-slot:selection="data">
                  {{ data.item.mcc }} -
                  {{ data.item.mcc_name }}
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              Kriteria
              {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-select
                id="merchantCriteria"
                ref="merchantCriteria"
                :items="listCriteria"
                return-object
                v-model="merchantCriteria"
                @change="$v.merchantCriteria.$touch()"
                @blur="$v.merchantCriteria.$touch()"
                :error-messages="merchantCriteriaErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Kota, Kecamatan, Kode Pos </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="kodepos"
                ref="kodepos"
                clearable
                v-model="kodepos"
                :items="itemsKodepos"
                :error-messages="kodeposErrors"
                @change="$v.kodepos.$touch()"
                @blur="
                  () => {
                    $v.kodepos.$touch();
                    checkKodepos();
                  }
                "
                :loading="isLoadingKodepos"
                :search-input.sync="searchKodepos"
                hide-selected
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Remark </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-textarea
                id="remarkPTEN"
                ref="remarkPTEN"
                rows="2"
                background-color="grey lighten-5"
                placeholder="Remark for PTEN"
                auto-grow
                v-model="remarkPTEN"
                :error-messages="remarkPTENErrors"
                @change="$v.remarkPTEN.$touch()"
                @blur="$v.remarkPTEN.$touch()"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> ID Approver 1 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="IDApprover1"
                ref="IDApprover1"
                clearable
                v-model="IDApprover1"
                :items="itemsApprovalId1"
                item-id="id"
                item-text="username"
                return-object
                @change="$v.IDApprover1.$touch()"
                @blur="$v.IDApprover1.$touch()"
                @focus="onFocusApprover1"
                :error-messages="IDApprover1Errors"
                :loading="isLoadingApprovalId1"
                :search-input.sync="searchApprovalId1"
                hide-selected
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> ID Approver 2 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="IDApprover2"
                ref="IDApprover2"
                clearable
                v-model="IDApprover2"
                :items="itemsApprovalId2"
                item-id="id"
                item-text="username"
                return-object
                @change="$v.IDApprover2.$touch()"
                @blur="$v.IDApprover2.$touch()"
                @focus="onFocusApprover2"
                :error-messages="IDApprover2Errors"
                :loading="isLoadingApprovalId2"
                :search-input.sync="searchApprovalId2"
                hide-selected
              />
            </v-col>
          </v-row>
          <v-divider />
          <v-row style="align-items: center" v-if="isEdit">
            <v-col cols="12">
              <v-textarea
                outlined
                id="remark"
                ref="remark"
                rows="6"
                label="Remark"
                placeholder="Remark for Internal"
                background-color="grey lighten-5"
                auto-grow
                v-model="remark"
                :error-messages="remarkErrors"
                @change="$v.remark.$touch()"
                @blur="$v.remark.$touch()"
              />
            </v-col>
          </v-row>
        </div>

        <div v-if="isEdit && !isUpdatePTEN">
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              Nama {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
            </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ merchantName }}
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> MPAN </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ mpan }}
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> NMID </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ nmid }}
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> MID </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ mid }}
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Nomor Rekening </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="noRekening"
                ref="noRekening"
                v-model="noRekening"
                @change="$v.noRekening.$touch()"
                @blur="$v.noRekening.$touch()"
                :error-messages="noRekeningErrors"
                :loading="isloadingRekening"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center" v-if="accountType == '2'">
            <v-col cols="10" sm="4"> Nama Perusahaan </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="companyName"
                ref="companyName"
                v-model="companyName"
                @change="$v.companyName.$touch()"
                @blur="$v.companyName.$touch()"
                :error-messages="companyNameErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Nama Pemilik Usaha </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="merchantOwnerName"
                ref="merchantOwnerName"
                v-model="merchantOwnerName"
                @change="$v.merchantOwnerName.$touch()"
                @blur="$v.merchantOwnerName.$touch()"
                :error-messages="merchantOwnerNameErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Email Pemilik Usaha</v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="email"
                ref="email"
                v-model="email"
                @change="$v.email.$touch()"
                @blur="$v.email.$touch()"
                :error-messages="emailErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> No Handphone Pemilik Usaha</v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="noHandphone"
                ref="noHandphone"
                v-model="noHandphone"
                @change="$v.noHandphone.$touch()"
                @blur="$v.noHandphone.$touch()"
                :error-messages="noHandphoneErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              No Handphone
              {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="noHandphoneMerchant"
                ref="noHandphoneMerchant"
                v-model="noHandphoneMerchant"
                @change="$v.noHandphoneMerchant.$touch()"
                @blur="$v.noHandphoneMerchant.$touch()"
                :error-messages="noHandphoneMerchantErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              No Telepon
              {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                id="areaCode"
                ref="areaCode"
                label="Area Code"
                clearable
                v-model="areaCode"
                :items="itemsAreaCode"
                item-text="kode_area"
                item-value="kode_area"
                :loading="isLoadingAreaCode"
                :search-input.sync="searchAreaCode"
                hide-selected
              >
                <template v-slot:item="data">
                  <template v-if="typeof data.item != 'object'">
                    <v-list-item-content>{{ data.item }}</v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        data.item.kode_area
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        data.item.wilayah
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                id="noTelpMerchant"
                ref="noTelpMerchant"
                @change="$v.noTelpMerchant.$touch()"
                @blur="$v.noTelpMerchant.$touch()"
                :error-messages="noTelpMerchantErrors"
                v-model="noTelpMerchant"
              />
            </v-col>
          </v-row>
          <v-row
            style="align-items: center"
            v-if="jenisUsaha.mcc_id != null && jenisUsaha.mcc_id != ''"
          >
            <v-col cols="10" sm="4"> MDR Khusus </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-checkbox
                id="isSpecialMdr"
                v-model="isSpecialMdr"
                color="primary"
                hide-details
              />
            </v-col>
          </v-row>
          <v-row
            style="align-items: center"
            v-if="jenisUsaha.mcc_id != null && jenisUsaha.mcc_id != ''"
          >
            <v-col cols="10" sm="4"> MDR On Us </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="mdronus"
                ref="mdronus"
                v-model="mdronus"
                @change="$v.mdronus.$touch()"
                @blur="$v.mdronus.$touch()"
                :error-messages="mdronusErrors"
                :disabled="!isSpecialMdr"
                :filled="!isSpecialMdr"
              />
            </v-col>
          </v-row>
          <v-row
            style="align-items: center"
            v-if="jenisUsaha.mcc_id != null && jenisUsaha.mcc_id != ''"
          >
            <v-col cols="10" sm="4"> MDR Off Us </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="mdroffus"
                ref="mdroffus"
                v-model="mdroffus"
                @change="$v.mdroffus.$touch()"
                @blur="$v.mdroffus.$touch()"
                :error-messages="mdroffusErrors"
                :disabled="!isSpecialMdr"
                :filled="!isSpecialMdr"
              />
            </v-col>
          </v-row>
          <v-row
            style="align-items: center"
            v-if="jenisUsaha.mcc_id != null && jenisUsaha.mcc_id != '' && isSpecialMdr"
          >
            <v-col cols="10" sm="4"> Dokumen MDR Khusus </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <div id="mdrFile">
                <FileUploadDropzone
                  v-model="mdrFile"
                  label="Dokumen MDR Khusus"
                  placeholder="Drag & drop file PDF atau klik untuk memilih"
                  :allowed-extensions="['pdf']"
                  :max-size="1048576"
                  upload-icon="mdi-cloud-upload"
                  file-icon="mdi-file-pdf-box"
                  progress-color="teal"
                  :errors="mdrFileErrors"
                  @change="onMdrFileChange"
                  @remove="onMdrFileRemove"
                  ref="mdrFileUpload"
                />
                <div v-if="mdrFile" class="mt-2 d-flex align-center">
                  <v-btn
                    small
                    color="primary"
                    outlined
                    @click="previewMdrFile"
                    class="mr-2"
                  >
                    <v-icon left small>mdi-eye</v-icon>
                    Preview
                  </v-btn>
                  <v-btn
                    small
                    color="success"
                    outlined
                    @click="downloadMdrFile"
                  >
                    <v-icon left small>mdi-download</v-icon>
                    Download
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
          <RegionalMappingFields
            :bcko.sync="bcko"
            :cmer.sync="cmer"
            :referralCode.sync="rmReferalCode"
            :itemsBcko="itemsBcko"
            :searchBcko.sync="searchBcko"
            :loadingBcko="isLoadingBcko"
            :itemsCmer="itemsCmer"
            :searchCmer.sync="searchCmer"
            :loadingCmer="isLoadingCmer"
            :bckoErrors="bckoErrors"
            :cmerErrors="cmerErrors"
            :referralCodeErrors="rmReferalCodeErrors"
            :disableBcko="false"
            :disableCmer="false"
            :disableReferral="isRegionalReferralCodeDisabled"
            :showSubMerchantInfo="false"
            :infoType="fieldInfoType"
            @touch-referral="$v.rmReferalCode.$touch()"
            @focus-bcko="onFocusBcko"
            @focus-cmer="onFocusCmer"
          />
          <v-row style="align-items: center" v-if="qrType == '2'">
            <v-col cols="10" sm="4"> endpoint URL </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="endpoint"
                ref="endpoint"
                v-model="endpoint"
                @change="$v.endpoint.$touch()"
                @blur="$v.endpoint.$touch()"
                :error-messages="endpointErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center" v-if="qrType == '2'">
            <v-col cols="10" sm="4"> IP Address </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="ipAddress"
                ref="ipAddress"
                v-model="ipAddress"
                @change="$v.ipAddress.$touch()"
                @blur="$v.ipAddress.$touch()"
                :error-messages="ipAddressErrors"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Remark </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-textarea
                id="remark"
                ref="remark"
                rows="2"
                background-color="grey lighten-5"
                auto-grow
                v-model="remark"
                :error-messages="remarkErrors"
                @change="$v.remark.$touch()"
                @blur="$v.remark.$touch()"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> ID Approver 1 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="IDApprover1"
                ref="IDApprover1"
                clearable
                v-model="IDApprover1"
                :items="itemsApprovalId1"
                item-id="id"
                item-text="username"
                return-object
                @change="$v.IDApprover1.$touch()"
                @blur="$v.IDApprover1.$touch()"
                @focus="onFocusApprover1"
                :error-messages="IDApprover1Errors"
                :loading="isLoadingApprovalId1"
                :search-input.sync="searchApprovalId1"
                hide-selected
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> ID Approver 2 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="IDApprover2"
                ref="IDApprover2"
                clearable
                v-model="IDApprover2"
                :items="itemsApprovalId2"
                item-id="id"
                item-text="username"
                return-object
                @change="$v.IDApprover2.$touch()"
                @blur="$v.IDApprover2.$touch()"
                @focus="onFocusApprover2"
                :error-messages="IDApprover2Errors"
                :loading="isLoadingApprovalId2"
                :search-input.sync="searchApprovalId2"
                hide-selected
              />
            </v-col>
          </v-row>
        </div>

        <div v-if="!isEdit">
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              Tipe
              {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-select
                id="accountTypeField"
                ref="accountTypeField"
                :items="listAccountType"
                item-text="text"
                item-value="value"
                v-model="accountTypeField"
                @change="
                  () => {
                    $v.accountTypeField.$touch();
                    qrType = '';
                  }
                "
                @blur="$v.accountTypeField.$touch()"
                :error-messages="accountTypeFieldErrors"
                :disabled="
                  isOutlet ||
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isOutlet ||
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Tipe QR</v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-select
                id="qrType"
                ref="qrType"
                :items="isFromAggregator ? qrItemsFiltered : qrItems"
                item-text="text"
                item-value="value"
                v-model="qrType"
                @change="$v.qrType.$touch()"
                @blur="$v.qrType.$touch()"
                :error-messages="qrTypeErrors"
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              />
            </v-col>
          </v-row>
          <EditMerchantInterfaceField
            v-if="isQrTypeWithAPI"
            :qr-type="qrType"
            :need-interface-value="needInterface"
            :qr-type-interface-value="qrTypeInterface"
            @update:needInterfaceValue="needInterface = $event"
            @update:qrTypeInterfaceValue="qrTypeInterface = $event"
          />

          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Nomor Rekening </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="noRekening"
                ref="noRekening"
                v-model="noRekening"
                @change="$v.noRekening.$touch()"
                @blur="$v.noRekening.$touch()"
                :error-messages="noRekeningErrors"
                :loading="isloadingRekening"
                :filled="isEditCloseMerchant || isEditBlockMerchant"
                :disabled="isEditCloseMerchant || isEditBlockMerchant"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center" v-if="accountType == '2'">
            <v-col cols="10" sm="4"> Nama Perusahaan </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="companyName"
                ref="companyName"
                v-model="companyName"
                @change="$v.companyName.$touch()"
                @blur="$v.companyName.$touch()"
                :error-messages="companyNameErrors"
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              Nama {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
            </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="merchantName"
                ref="merchantName"
                v-model="merchantName"
                @change="$v.merchantName.$touch()"
                @blur="$v.merchantName.$touch()"
                :error-messages="merchantNameErrors"
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Nama Pemilik Usaha </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="merchantOwnerName"
                ref="merchantOwnerName"
                v-model="merchantOwnerName"
                @change="$v.merchantOwnerName.$touch()"
                @blur="$v.merchantOwnerName.$touch()"
                :error-messages="merchantOwnerNameErrors"
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Nomor KTP Pemilik Usaha </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="noKTP"
                ref="noKTP"
                v-model="noKTP"
                :counter="16"
                @change="$v.noKTP.$touch()"
                @blur="$v.noKTP.$touch()"
                :error-messages="noKTPErrors"
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              Nomor NPWP
              {{ accountType == '2' ? 'Perusahaan' : 'Pemilik Usaha' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="noNPWP"
                ref="noNPWP"
                v-model="noNPWP"
                :append-icon="!isCorporate ? 'mdi-orbit-variant' : ''"
                :suffix="!isCorporate ? 'Samakan dengan No KTP' : ''"
                :counter="16"
                @click:append="copyNoKTPtoNPWP"
                @change="$v.noNPWP.$touch()"
                @blur="$v.noNPWP.$touch()"
                :error-messages="noNPWPErrors"
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Email Pemilik Usaha</v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="email"
                ref="email"
                v-model="email"
                @change="$v.email.$touch()"
                @blur="$v.email.$touch()"
                :error-messages="emailErrors"
                :filled="
                  isOutlet ||
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :readonly="
                  isOutlet ||
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> No Handphone Pemilik Usaha</v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="noHandphone"
                ref="noHandphone"
                v-model="noHandphone"
                @change="$v.noHandphone.$touch()"
                @blur="$v.noHandphone.$touch()"
                :error-messages="noHandphoneErrors"
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              No Handphone
              {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="noHandphoneMerchant"
                ref="noHandphoneMerchant"
                v-model="noHandphoneMerchant"
                @change="$v.noHandphoneMerchant.$touch()"
                @blur="$v.noHandphoneMerchant.$touch()"
                :error-messages="noHandphoneMerchantErrors"
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              No Telepon
              {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                id="areaCode"
                ref="areaCode"
                label="Area Code"
                clearable
                v-model="areaCode"
                :items="itemsAreaCode"
                item-text="kode_area"
                item-value="kode_area"
                :loading="isLoadingAreaCode"
                :search-input.sync="searchAreaCode"
                hide-selected
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              >
                <template v-slot:item="data">
                  <template v-if="typeof data.item != 'object'">
                    <v-list-item-content>{{ data.item }}</v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        data.item.kode_area
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        data.item.wilayah
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                id="noTelpMerchant"
                ref="noTelpMerchant"
                @change="$v.noTelpMerchant.$touch()"
                @blur="$v.noTelpMerchant.$touch()"
                :error-messages="noTelpMerchantErrors"
                v-model="noTelpMerchant"
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">Channel QR</v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="channelQr"
                ref="channelQr"
                clearable
                v-model="channelQr"
                :items="channelQrFiltered"
                item-text="desc"
                item-value="code"
                label="Channel QR"
                :loading="isLoadingChannelQR"
                :error-messages="channelQrErrors"
                @focus="loadChannelQrList"
                @change="$v.channelQr.$touch()"
                @blur="$v.channelQr.$touch()"
              >
                <template v-slot:item="data">
                  <template v-if="typeof data.item != 'object'">
                    <v-list-item-content>{{ data.item }}</v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title>{{ data.item.code }}</v-list-item-title>
                      <v-list-item-subtitle>{{ data.item.desc }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">Model Usaha</v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-select
                id="merchantModel"
                ref="merchantModel"
                v-model="merchantModel"
                :items="listMerchantModel"
                item-text="text"
                item-value="value"
                label="Model Usaha"
                :error-messages="merchantModelErrors"
                @change="$v.merchantModel.$touch()"
                @blur="$v.merchantModel.$touch()"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">Jenis Usaha</v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="jenisUsaha"
                ref="jenisUsaha"
                clearable
                v-model="jenisUsaha"
                :items="itemsJenisUsaha"
                item-text="mcc_name"
                return-object
                :filter="customFilter"
                :error-messages="jenisUsahaErrors"
                @change="$v.jenisUsaha.$touch()"
                @blur="$v.jenisUsaha.$touch()"
                :loading="isLoadingJenisUsaha"
                hide-selected
                single-line
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              >
                <template v-slot:item="data">
                  <template v-if="typeof data.item != 'object'">
                    <v-list-item-content>{{ data.item }}</v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title
                        >{{ data.item.mcc }} -
                        {{ data.item.mcc_name }}</v-list-item-title
                      >
                    </v-list-item-content>
                  </template>
                </template>
                <template v-slot:selection="data">
                  {{ data.item.mcc }} -
                  {{ data.item.mcc_name }}
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4">
              Kriteria
              {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-select
                id="merchantCriteria"
                ref="merchantCriteria"
                :items="listCriteria"
                return-object
                v-model="merchantCriteria"
                @change="$v.merchantCriteria.$touch()"
                @blur="$v.merchantCriteria.$touch()"
                :error-messages="merchantCriteriaErrors"
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              />
            </v-col>
          </v-row>

          <v-row style="align-items: center" v-if="showMDRForm">
            <v-col cols="10" sm="4"> MDR Khusus </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-checkbox
                id="isSpecialMdr2"
                v-model="isSpecialMdr"
                color="primary"
                hide-details
                :disabled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center" v-if="showMDRForm">
            <v-col cols="10" sm="4"> MDR On Us </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="mdronus"
                ref="mdronus"
                v-model="mdronus"
                @change="$v.mdronus.$touch()"
                @blur="$v.mdronus.$touch()"
                :error-messages="mdronusErrors"
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant ||
                  !isSpecialMdr
                "
                :disabled="!isSpecialMdr"
                :loading="loadingMdr"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center" v-if="showMDRForm">
            <v-col cols="10" sm="4"> MDR Off Us </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="mdroffus"
                ref="mdroffus"
                v-model="mdroffus"
                @change="$v.mdroffus.$touch()"
                @blur="$v.mdroffus.$touch()"
                :error-messages="mdroffusErrors"
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant ||
                  !isSpecialMdr
                "
                :disabled="!isSpecialMdr"
                :loading="loadingMdr"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center" v-if="showMDRForm && isSpecialMdr">
            <v-col cols="10" sm="4"> Dokumen MDR Khusus </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <div id="mdrFile2">
                <FileUploadDropzone
                  v-model="mdrFile"
                  label="Dokumen MDR Khusus"
                  placeholder="Drag & drop file PDF atau klik untuk memilih"
                  :allowed-extensions="['pdf']"
                  :max-size="1048576"
                  upload-icon="mdi-cloud-upload"
                  file-icon="mdi-file-pdf-box"
                  progress-color="teal"
                  :errors="mdrFileErrors"
                  @change="onMdrFileChange"
                  @remove="onMdrFileRemove"
                  ref="mdrFileUpload2"
                />
                <div v-if="mdrFile" class="mt-2 d-flex align-center">
                  <v-btn
                    small
                    color="primary"
                    outlined
                    @click="previewMdrFile"
                    class="mr-2"
                  >
                    <v-icon left small>mdi-eye</v-icon>
                    Preview
                  </v-btn>
                  <v-btn
                    small
                    color="success"
                    outlined
                    @click="downloadMdrFile"
                  >
                    <v-icon left small>mdi-download</v-icon>
                    Download
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Alamat Perusahaan </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-textarea
                id="alamatMerchant"
                ref="alamatMerchant"
                rows="2"
                background-color="grey lighten-5"
                auto-grow
                v-model="alamatMerchant"
                @change="$v.alamatMerchant.$touch()"
                @blur="$v.alamatMerchant.$touch()"
                :error-messages="alamatMerchantErrors"
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Kota, Kecamatan, Kode Pos </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="kodepos"
                ref="kodepos"
                clearable
                v-model="kodepos"
                :items="itemsKodepos"
                :error-messages="kodeposErrors"
                @change="$v.kodepos.$touch()"
                @blur="
                  () => {
                    $v.kodepos.$touch();
                    checkKodepos();
                  }
                "
                :loading="isLoadingKodepos"
                :search-input.sync="searchKodepos"
                hide-selected
                :readonly="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
                :filled="
                  isEditResettlement ||
                  isEditCloseMerchant ||
                  isEditBlockMerchant
                "
              />
            </v-col>
          </v-row>
          <RegionalMappingFields
            :bcko.sync="bcko"
            :cmer.sync="cmer"
            :referralCode.sync="rmReferalCode"
            :itemsBcko="itemsBcko"
            :searchBcko.sync="searchBcko"
            :loadingBcko="isLoadingBcko"
            :itemsCmer="itemsCmer"
            :searchCmer.sync="searchCmer"
            :loadingCmer="isLoadingCmer"
            :bckoErrors="bckoErrors"
            :cmerErrors="cmerErrors"
            :referralCodeErrors="rmReferalCodeErrors"
            :disableBcko="false"
            :disableCmer="false"
            :disableReferral="isRegionalReferralCodeDisabled"
            :showSubMerchantInfo="false"
            :infoType="fieldInfoType"
            @touch-referral="$v.rmReferalCode.$touch()"
            @focus-bcko="onFocusBcko"
            @focus-cmer="onFocusCmer"
          />
          <v-row style="align-items: center" v-if="qrType == '2'">
            <v-col cols="10" sm="4"> endpoint URL </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="endpoint"
                ref="endpoint"
                v-model="endpoint"
                @change="$v.endpoint.$touch()"
                @blur="$v.endpoint.$touch()"
                :error-messages="endpointErrors"
                :filled="isEditResettlement || isEditBlockMerchant"
                :readonly="isEditResettlement || isEditBlockMerchant"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center" v-if="qrType == '2'">
            <v-col cols="10" sm="4"> IP Address </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="ipAddress"
                ref="ipAddress"
                v-model="ipAddress"
                @change="$v.ipAddress.$touch()"
                @blur="$v.ipAddress.$touch()"
                :error-messages="ipAddressErrors"
                :filled="isEditResettlement || isEditBlockMerchant"
                :readonly="isEditResettlement || isEditBlockMerchant"
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> ID Approver 1 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="IDApprover1"
                ref="IDApprover1"
                clearable
                v-model="IDApprover1"
                :items="itemsApprovalId1"
                item-id="id"
                item-text="username"
                return-object
                @change="$v.IDApprover1.$touch()"
                @blur="$v.IDApprover1.$touch()"
                @focus="onFocusApprover1"
                :error-messages="IDApprover1Errors"
                :loading="isLoadingApprovalId1"
                :search-input.sync="searchApprovalId1"
                hide-selected
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> ID Approver 2 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="IDApprover2"
                ref="IDApprover2"
                clearable
                v-model="IDApprover2"
                :items="itemsApprovalId2"
                item-id="id"
                item-text="username"
                return-object
                @change="$v.IDApprover2.$touch()"
                @blur="$v.IDApprover2.$touch()"
                @focus="onFocusApprover2"
                :error-messages="IDApprover2Errors"
                :loading="isLoadingApprovalId2"
                :search-input.sync="searchApprovalId2"
                hide-selected
              />
            </v-col>
          </v-row>
          <v-card
            class="mb-12"
            height="20px"
            :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
            v-if="isAdd"
          >
            <div class="d-flex pa-5 flex-column align-center justify-center">
              <h3 class="mb-5">NMID</h3>
            </div>
          </v-card>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> NMID </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                id="nmid"
                ref="nmid"
                v-model="nmid"
                @change="$v.nmid.$touch()"
                @blur="$v.nmid.$touch()"
                :error-messages="nmidErrors"
                :filled="!isAdd"
                :readonly="!isAdd"
              />
            </v-col>
          </v-row>

          <v-card
            class="mb-12"
            height="20px"
            :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
            v-if="isAdd"
          >
            <div class="d-flex pa-5 flex-column align-center justify-center">
              <h3 class="mb-5">Syarat & Ketentuan</h3>
            </div>
          </v-card>
          <v-card
            v-if="!isEditCloseMerchant || !isEditBlockMerchant"
            elevation="2"
            :style="{
              height: '350px',
              overflow: 'auto',
              margin: '10px',
            }"
          >
            <v-fab-transition>
              <v-btn
                class="mx-2"
                fab
                dark
                small
                color="primary"
                :style="{
                  position: 'absolute',
                  top: '0',
                  right: '0',
                  margin: '10px',
                  'z-index': '2',
                }"
                @click="printThePDF(pdfFileSK)"
              >
                <v-icon dark> mdi-printer </v-icon>
              </v-btn>
            </v-fab-transition>
            <pdf
              ref="pdfSK"
              :src="pdfFileSK"
              @num-pages="numPages = $event"
            />
            <div v-for="i in numPages" :key="i" style="margin-bottom: 12px">
              <pdf :src="pdfFileSK" :page="i" />
            </div>

          </v-card>
          <v-row v-if="!isEditCloseMerchant || !isEditBlockMerchant">
            <v-checkbox
              id="sk"
              ref="sk"
              v-model="sk"
              :label="`Dengan ini saya menyatakan bahwa form ini telah saya isi dengan benar, dan saya setuju dengan semua syarat dan ketentuan.`"
              :style="{ margin: '20px' }"
              @change="$v.sk.$touch()"
              @blur="$v.sk.$touch()"
              :error-messages="skErrors"
            />
          </v-row>
          <v-card
            class="mb-12"
            height="20px"
            :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
            v-if="isAdd"
          >
            <div class="d-flex pa-5 flex-column align-center justify-center">
              <h3 class="mb-5">MID</h3>
            </div>
          </v-card>

          <div v-if="isAdd">
            <v-row style="align-items: center">
              <v-col cols="10" sm="4"> MID </v-col>
              <v-col cols="2" sm="1"> : </v-col>
              <v-col cols="12" sm="7">
                <v-text-field
                  id="mid"
                  ref="mid"
                  :counter="midMinLength"
                  @change="$v.mid.$touch()"
                  @blur="$v.mid.$touch()"
                  :error-messages="midErrors"
                  v-model="mid"
                />
              </v-col>
            </v-row>
          </div>

          <v-row
            style="align-items: center"
            v-if="isEditCloseMerchant || isEditBlockMerchant"
          >
            <v-col cols="10" sm="4"> Reason </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-textarea
                id="reason"
                ref="reason"
                rows="2"
                background-color="grey lighten-5"
                auto-grow
                v-model="reason"
                :error-messages="reasonErrors"
                @change="$v.reason.$touch()"
                @blur="$v.reason.$touch()"
              />
            </v-col>
          </v-row>

          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Remark </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-textarea
                id="remark"
                ref="remark"
                rows="2"
                background-color="grey lighten-5"
                auto-grow
                v-model="remark"
                :error-messages="remarkErrors"
                @change="$v.remark.$touch()"
                @blur="$v.remark.$touch()"
              />
            </v-col>
          </v-row>
        </div>

        <v-card :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }">
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3>Additional Data</h3>
          </div>
        </v-card>

        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Tempat Lahir Pemilik Usaha </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="ownerCityofBirth"
              ref="ownerCityofBirth"
              v-model="ownerCityofBirth"
              :readonly="isEditCloseMerchant || isEditBlockMerchant"
              :filled="isEditCloseMerchant || isEditBlockMerchant"
            />
          </v-col>
        </v-row>

        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Tanggal Lahir Pemilik Usaha </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="ownerDateofBirth"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="ownerDateofBirth"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :filled="isEditCloseMerchant || isEditBlockMerchant"
                />
              </template>
              <v-date-picker
                v-if="!isEditCloseMerchant || !isEditBlockMerchant"
                v-model="ownerDateofBirth"
                no-title
                scrollable
                :readonly="isEditCloseMerchant || isEditBlockMerchant"
              >
                <v-spacer />
                <v-btn text color="primary" @click="menu = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(ownerDateofBirth)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Alamat Pemilik Usaha</v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-textarea
              id="ownerAddress"
              ref="ownerAddress"
              rows="2"
              background-color="grey lighten-5"
              auto-grow
              v-model="ownerAddress"
              :readonly="isEditCloseMerchant || isEditBlockMerchant"
              :filled="isEditCloseMerchant || isEditBlockMerchant"
            />
          </v-col>
        </v-row>

        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Kode Pos Pemilik Usaha </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-autocomplete
              id="owner_postal_code"
              ref="owner_postal_code"
              clearable
              v-model="ownerPostalCode"
              :items="itemsKodeposOwner"
              @blur="checkownerPostalCode"
              :loading="isLoadingownerPostalCode"
              :search-input.sync="searchownerPostalCode"
              hide-selected
              :readonly="isEditCloseMerchant || isEditBlockMerchant"
              :filled="isEditCloseMerchant || isEditBlockMerchant"
            />
          </v-col>
        </v-row>

        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Nama Pemilik Rekening </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="accountHolderName"
              ref="accountHolderName"
              v-model="accountHolderName"
              :readonly="isEditCloseMerchant || isEditBlockMerchant"
              :filled="isEditCloseMerchant || isEditBlockMerchant"
            />
          </v-col>
        </v-row>

        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Kantor Cabang Terdekat </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="bniBranchOffice"
              ref="bniBranchOffice"
              v-model="bniBranchOffice"
              :readonly="isEditCloseMerchant || isEditBlockMerchant"
              :filled="isEditCloseMerchant || isEditBlockMerchant"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Tahun Berdiri </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="merchantEstSince"
              ref="merchantEstSince"
              v-model="merchantEstSince"
              @change="$v.merchantEstSince.$touch()"
              @blur="$v.merchantEstSince.$touch()"
              :error-messages="merchantEstSinceErrors"
              :readonly="isEditCloseMerchant || isEditBlockMerchant"
              :filled="isEditCloseMerchant || isEditBlockMerchant"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Email Merchant </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="merchantEmail"
              ref="merchantEmail"
              v-model="merchantEmail"
              @change="$v.merchantEmail.$touch()"
              @blur="$v.merchantEmail.$touch()"
              :error-messages="merchantEmailErrors"
              :readonly="isEditCloseMerchant || isEditBlockMerchant"
              :filled="isEditCloseMerchant || isEditBlockMerchant"
            />
          </v-col>
        </v-row>

        <div v-if="isImageDokumen">
          <v-card
            class="mb-12"
            height="20px"
            :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
          >
            <div class="d-flex pa-5 flex-column align-center justify-center">
              <h3>Dokumen</h3>
            </div>
          </v-card>

          <v-row>
            <v-col cols="10" sm="4"> Foto Selfi </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-card elevation="2">
                <v-img :src="data.image_selfie" />
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="10" sm="4"> Foto KTP </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-card elevation="2">
                <v-img :src="data.image_ktp" />
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="10" sm="4"> Foto Selfi KTP </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-card elevation="2">
                <v-img :src="data.image_selfie_ktp" />
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="10" sm="4"> Foto TTD </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-card elevation="2">
                <v-img :src="data.image_tanda_tangan" />
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="10" sm="4"> Foto Lokasi Usaha </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-card elevation="2">
                <v-img :src="data.image_lokasi" />
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="10" sm="4"> Foto NPWP </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-card elevation="2">
                <v-img :src="data.image_npwp" />
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="10" sm="4"> Foto NIB </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-card elevation="2">
                <app-pdf-viewer
                  :id="$route.params.id"
                  :pdfData="data.image_nib"
                  pdfType="pdfNibView"
                />
              </v-card>
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col cols="12">
            <div class="d-flex justify-space-between">
              <v-btn
                small
                color="orange"
                :disabled="saveLoading"
                :style="{ margin: '2px', color: 'white' }"
                @click="back"
              >
                <v-icon dark left> mdi-arrow-left </v-icon>
                Back
              </v-btn>
              <v-btn
                small
                color="blue"
                :disabled="saveLoading"
                :loading="saveLoading"
                :style="{ margin: '2px', color: 'white' }"
                @click="save"
              >
                save
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import {
  required,
  email,
  numeric,
  maxLength,
  ipAddress,
  url,
} from 'vuelidate/lib/validators';
import printJS from 'print-js';
import FileUploadDropzone from '@/components/form/FileUploadDropzone.vue';
import RegionalMappingFields from '@/components/inputer/RegionalMappingFields.vue';
import regionalMappingDaftarTugasMixin from '@/components/daftar-tugas/fields/merchant/mixin';
import regionalMappingValidationDaftarTugasMixin from '@/components/daftar-tugas/fields/merchant/validation';
import {
  dataListIdApprover,
  dataListMerchantCriteria,
  dataQrType,
  validations,
  scrollOptions,
  dataUserRoles,
  dataTipeMerchantOnboarding,
  listMerchantModel,
  qrByMerchantType,
  dataDelayServiceHit,
  dataCptsMdrValues,
} from '../../store/params';

import {
  isEmpty,
  date,
  regexNumericDecimal,
  regexDoesNotContainPipe,
  checkRegexAlphanumChar,
  checkRegexDoesNotContainPipe,
  regexNumberValidate,
} from '../../lib/helpers';

export default {
  components: {
    pdf: () => import('vue-pdf'),
    AppPdfViewer: () => import('../../components/form/AppPdfViewer.vue'),
    EditMerchantInterfaceField: () => import('../../components/daftar-tugas/fields/EditMerchantInterfaceField.vue'),
    FileUploadDropzone,
    RegionalMappingFields,
  },
  mixins: [validationMixin, regionalMappingDaftarTugasMixin, regionalMappingValidationDaftarTugasMixin],
  validations: {
    ...regionalMappingValidationDaftarTugasMixin.validations,
    accountTypeField: {
      required() {
        if (this.isUpdatePTEN || !this.isEdit) {
          return this.accountTypeField != '';
        }
        return true;
      },
    },
    qrType: {
      required() {
        if (this.isUpdatePTEN || !this.isEdit) {
          return this.qrType != '';
        }
        return true;
      },
    },
    channelQr: {
      required() {
        if (!this.isEdit) {
          return this.channelQr != '';
        }
        return true;
      },
    },
    merchantModel: {
      required() {
        if (!this.isEdit) {
          return this.merchantModel != '';
        }
        return true;
      },
    },
    qrTypeInterface: {
      required() {
        if (this.isQrTypeWithAPI && this.needInterface) {
          return this.qrTypeInterface.length > 0;
        }
        return true;
      },
    },
    noRekening: {
      required() {
        if (!this.isUpdatePTEN || !this.isEdit) {
          return this.noRekening != '';
        }
        return true;
      },
      numeric,
      isUnique() {
        if (!this.isUpdatePTEN || !this.isEdit) {
          return (
            this.errorValidation != null &&
            (this.errorValidation.account_number == null ||
              this.errorValidation.account_number.length < 1)
          );
        }
        return true;
      },
      isRekVc() {
        if (!this.isUpdatePTEN || !this.isEdit) {
          return (
            this.noRekening.length == 9 ||
            this.noRekening.length == 10 ||
            this.noRekening.length == 16
          );
        }
        return true;
      },
    },
    companyName: {
      required() {
        if ((this.isAdd || !this.isUpdatePTEN) && this.accountType == '2') {
          return this.companyName != '';
        }
        return true;
      },
      alphanumChar() {
        if ((this.isAdd || !this.isUpdatePTEN) && this.accountType == '2') {
          return checkRegexAlphanumChar(this.companyName);
        }
        return true;
      },
    },
    merchantName: {
      required() {
        if (this.isUpdatePTEN || !this.isEdit) {
          return this.merchantName != '';
        }
        return true;
      },
      alphanumChar() {
        if (this.isUpdatePTEN || !this.isEdit) {
          return checkRegexAlphanumChar(this.merchantName);
        }
        return true;
      },
      numberValidate: regexNumberValidate,
      merchantCriteriaMcc() {
        return this.criteriaQuote || this.criteriaQuote == null;
      },
    },
    merchantOwnerName: {
      required() {
        if (!this.isUpdatePTEN || !this.isEdit) {
          return this.merchantOwnerName != '';
        }
        return true;
      },
      alphanumChar() {
        if (!this.isUpdatePTEN || !this.isEdit) {
          return checkRegexAlphanumChar(this.merchantOwnerName);
        }
        return true;
      },
    },
    noKTP: {
      required,
      numeric,
      maxLength: maxLength(16),
      minLength() {
        if (
          (this.isUpdatePTEN && !this.isCorporate) ||
          (!this.isEdit && !this.isCorporate)
        ) {
          return this.noKTP.length == 16;
        }
        if (this.noKTP.length > 0) {
          return this.noKTP.length == 16;
        }
        return true;
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.ktp_no == null ||
            this.errorValidation.ktp_no.length < 1)
        );
      },
    },
    noNPWP: {
      required() {
        if (
          (this.isUpdatePTEN && this.isCorporate) ||
          (!this.isEdit && this.isCorporate)
        ) {
          return this.noNPWP != '';
        }
        return true;
      },
      numeric,
      maxLength() {
        if (
          (this.isUpdatePTEN && this.isCorporate) ||
          (!this.isEdit && this.isCorporate)
        ) {
          return !(this.noNPWP == null || this.noNPWP.length != 16);
        }
        return true;
      },
      minLength() {
        if (
          (this.isUpdatePTEN && this.isCorporate) ||
          (!this.isEdit && this.isCorporate)
        ) {
          return !(this.noNPWP == null || this.noNPWP.length != 16);
        }
        if (this.noNPWP != null && this.noNPWP.length > 0) {
          return this.noNPWP.length == 16;
        }
        return true;
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.npwp_no == null ||
            this.errorValidation.npwp_no.length < 1)
        );
      },
    },
    email: {
      required() {
        if (!this.isUpdatePTEN || !this.isEdit) {
          return this.email != '';
        }
        return true;
      },
      email,
      doesNotContainPipe: regexDoesNotContainPipe,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.email == null ||
            this.errorValidation.email.length < 1)
        );
      },
    },
    noHandphone: {
      required() {
        if (!this.isUpdatePTEN || !this.isEdit) {
          return this.noHandphone != '';
        }
        return true;
      },
      numeric,
      maxLength: maxLength(15),
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.mobile_phone == null ||
            this.errorValidation.mobile_phone.length < 1)
        );
      },
    },
    noHandphoneMerchant: {
      required() {
        if (!this.isUpdatePTEN || !this.isEdit) {
          return this.noHandphoneMerchant != '';
        }
        return true;
      },
      numeric,
      maxLength: maxLength(15),
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.merchant_mobile_phone == null ||
            this.errorValidation.merchant_mobile_phone.length < 1)
        );
      },
    },
    noTelpMerchant: { numeric },
    jenisUsaha: {
      required() {
        if (this.isUpdatePTEN || !this.isEdit) {
          return this.jenisUsaha.mcc_id != '';
        }
        return true;
      },
    },
    mdronus: {
      minVal() {
        return !(
          (!this.isUpdatePTEN || !this.isEdit) &&
          this.mdronus < process.env.VUE_APP_MIN_MDR
        );
      },
      maxVal() {
        if (!this.isCPTS) {
          return !(
            (!this.isUpdatePTEN || !this.isEdit) &&
            parseFloat(this.mdronus) > parseFloat(process.env.VUE_APP_MAX_MDR)
          );
        }
        const merchantId = String(this.merchantTypeId);
        const maxValue = merchantId === '1' 
          ? dataCptsMdrValues.merchant.mdr_on_us 
          : dataCptsMdrValues.sub_merchant.mdr_on_us;
        return !(
          (!this.isUpdatePTEN || !this.isEdit) &&
          parseFloat(this.mdronus) > maxValue
        );
      },
      required() {
        if (!this.isUpdatePTEN || !this.isEdit) {
          return this.mdronus !== '' && this.mdronus !== null && this.mdronus !== undefined;
        }
        return true;
      },
      isValidMdr() {
        if (!this.isUpdatePTEN || !this.isEdit) {
          return (
            this.errorValidation != null &&
            (this.errorValidation.mdr_on_us == null ||
              this.errorValidation.mdr_on_us.length < 1)
          );
        }
        return true;
      },
      numericDecimal: regexNumericDecimal,
    },
    mdroffus: {
      minVal() {
        return !(
          (!this.isUpdatePTEN || !this.isEdit) &&
          this.mdroffus < process.env.VUE_APP_MIN_MDR
        );
      },
      maxVal() {
        if (!this.isCPTS) {
          return !(
            (!this.isUpdatePTEN || !this.isEdit) &&
            parseFloat(this.mdroffus) > parseFloat(process.env.VUE_APP_MAX_MDR)
          );
        }
        const merchantId = String(this.merchantTypeId);
        const maxValue = merchantId === '1' 
          ? dataCptsMdrValues.merchant.mdr_off_us 
          : dataCptsMdrValues.sub_merchant.mdr_off_us;
        return !(
          (!this.isUpdatePTEN || !this.isEdit) &&
          parseFloat(this.mdroffus) > maxValue
        );
      },
      required() {
        if (!this.isUpdatePTEN || !this.isEdit) {
          return this.mdroffus !== '' && this.mdroffus !== null && this.mdroffus !== undefined;
        }
        return true;
      },
      isValidMdr() {
        return (
          ((!this.isUpdatePTEN || !this.isEdit) &&
            this.errorValidation == null) ||
          this.errorValidation?.mdr_off_us == null ||
          this.errorValidation?.mdr_off_us.length < 1
        );
      },
      numericDecimal: regexNumericDecimal,
    },
    mdrFile: {
      required() {
        if ((!this.isUpdatePTEN || !this.isEdit) && this.isSpecialMdr) {
          return this.mdrFile != null;
        }
        return true;
      },
      maxSize() {
        if (this.mdrFile != null) {
          return this.mdrFile.size <= 1048576;
        }
        return true;
      },
      fileType() {
        if (this.mdrFile != null) {
          return this.mdrFile.type === 'application/pdf';
        }
        return true;
      },
    },
    merchantCriteria: {
      required() {
        if (this.isUpdatePTEN || !this.isEdit) {
          return this.merchantCriteria != '';
        }
        return true;
      },

      criteriaRange() {
        if (this.isUpdatePTEN || !this.isEdit) return !!this.rangeUbe;
        return true;
      },
      criteriaUre() {
        if (this.isUpdatePTEN || !this.isEdit) return !!this.rangeUre;
        return true;
      },
    },
    alamatMerchant: {
      required() {
        if (!this.isUpdatePTEN || !this.isEdit) {
          return this.alamatMerchant != '';
        }
        return true;
      },
      doesNotContainPipe() {
        if (!this.isUpdatePTEN || !this.isEdit) {
          return checkRegexDoesNotContainPipe(this.alamatMerchant);
        }
        return true;
      },
    },
    kodepos: {
      required() {
        if (this.isUpdatePTEN || !this.isEdit) {
          return !isEmpty(this.kodepos);
        }
        return true;
      },
    },
    endpoint: {
      url() {
        if (this.qrType == '2') {
          return url;
        }
        return true; 
      }
    },
    ipAddress: {
      customValidation(value) {
        // Only validate if there's a value
        if (value && value.trim() !== '') {
          return ipAddress(value);
        }
        return true;
      },
    },
    remark: { required },
    IDApprover1: {
      required() {
        return !isEmpty(this.IDApprover1.id);
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.approver_1 == null ||
            this.errorValidation.approver_1.length < 1)
        );
      },
    },
    IDApprover2: {
      required() {
        return !isEmpty(this.IDApprover2.id);
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.approver_2 == null ||
            this.errorValidation.approver_2.length < 1)
        );
      },
    },
    nmid: {},
    mpan: {},
    sk: {
      required() {
        if (this.isAdd) {
          return this.sk != '';
        }
        return true;
      },
    },
    mid: {
      required() {
        if (this.isAdd) {
          return this.mid != '';
        }
        return true;
      },
      minLength() {
        if (this.isAdd) {
          return this.mid.length >= validations.mid.min_length;
        }
        return true;
      },
      maxLength() {
        if (this.isAdd) {
          return this.mid.length <= validations.mid.max_length;
        }
        return true;
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.mid == null ||
            this.errorValidation.mid.length < 1)
        );
      },
      numeric,
    },
    remarkPTEN: {
      required() {
        if (this.isEdit && this.isUpdatePTEN) {
          return this.remarkPTEN != '';
        }
        return true;
      },
      minLength() {
        if (this.isEdit && this.isUpdatePTEN) {
          return this.remarkPTEN.length >= validations.remarkPTEN.min_length;
        }
        return true;
      },
      maxLength() {
        if (this.isEdit && this.isUpdatePTEN) {
          return this.remarkPTEN.length <= validations.remarkPTEN.max_length;
        }
        return true;
      },
    },
    reason: {
      required() {
        if (this.isEditCloseMerchant) {
          return this.reason != '';
        }
        return true;
      },
      minLength() {
        if (this.isEditCloseMerchant) {
          return this.reason.length >= 5;
        }
        return true;
      },
      maxLength() {
        if (this.isEditCloseMerchant) {
          return this.reason.length <= 50;
        }
        return true;
      },
    },
    merchantEstSince: {
      numeric,
    },
    merchantEmail: {
      email,
      doesNotContainPipe: regexDoesNotContainPipe,
    },
  },
  mounted() {
    this.$store.commit('master/daerah/list/clearApprovalId');
    
    this.getAreaCode();
    this.getJenisUsaha();
    this.getDetailData();
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      isLoadingJenisUsaha: false,
      listIDApprover: dataListIdApprover,
      listCriteria: dataListMerchantCriteria,
      listUserRoles: dataUserRoles,
      listAccountType: dataTipeMerchantOnboarding,
      listQRTypeIndividu: dataQrType,
      isLoadingAreaCode: false,
      isLoadingKodepos: false,
      isLoadingownerPostalCode: false,
      isLoadingApprovalId1: false,
      isLoadingApprovalId2: false,
      midMinLength: validations.mid.min_length,
      midMaxLength: validations.mid.max_length,
      tidMinLength: validations.tid.min_length,
      tidMaxLength: validations.tid.max_length,
      remarkPTENMinLength: validations.remarkPTEN.min_length,
      remarkPTENMaxLength: validations.remarkPTEN.max_length,
      searchApprovalId1: '',
      searchApprovalId2: '',
      approver1Loaded: false,
      approver2Loaded: false,
      searchAreaCode: '',
      searchKodepos: '',
      searchownerPostalCode: '',
      searchJenisUsaha: '',
      tempUniqueData: {
        account_number: '',
        aggre_pic_ktp_no: '',
        aggre_pic_email: '',
        npwp_no: '',
        ktp_no: '',
        email: '',
      },
      isHaveQRIS: '0',
      remark: '',
      remarkPTEN: '',
      reason: '',
      merchantCriteriaValue: '',
      criteriaQuote: null,
      rangeUbe: null,
      rangeUre: null,
      jenisUsahaQuote: '',
      qrisFile: null,
      validate: validations,
      allFile: [],
      listQrType: dataQrType,
      idTaskAdd: ['0', '2', '3'],
      idTaskEdit: ['4', '5'],
      sk: false,
      individuQR: [],
      corporateQR: [],
      delayHitServiceA1: null,
      delayHitServiceA2: null,
      isloadingRekening: false,
      menu: false,
      loadingMdr: false,
      isPageUpdate: true,
      channelQr: '',
      isLoadingChannelQR: false,
      merchantModel: '',
      needInterface: false,
      qrTypeInterface: [],
      isSpecialMdr: false,
      mdrFile: null,
      defaultMdrOnUs: '',
      defaultMdrOffUs: '',
      numPages: 0,
      ptenMdrOnUs: '',
      ptenMdrOffUs: '',
      loadingPtenMdr: false,
      ptenMdrTimeout: null,
      originalDetailMdrOnUs: null,
      originalDetailMdrOffUs: null,
      isInitialLoad: true,
      useStaticMdrForPten: true,
    };
  },
  watch: {
    isSpecialMdr: {
      handler(val) {
        if (!val) {
          this.mdrFile = null;
          if (this.$v.mdrFile) {
            this.$v.mdrFile.$reset();
          }
          if (this.defaultMdrOnUs && this.defaultMdrOffUs) {
            this.$store.commit('daftarTugas/rm/setMerchantVariable', {
              variable: 'mdr_on_us',
              payload: this.defaultMdrOnUs,
            });
            this.$store.commit('daftarTugas/rm/setMerchantVariable', {
              variable: 'mdr_off_us',
              payload: this.defaultMdrOffUs,
            });
          }
        } else if (this.$v.mdrFile) {
          this.$v.mdrFile.$touch();
        }
      },
    },
    qrisFile: {
      handler(val) {
        if (val != null) {
          this.checkQRIS();
        } else {
          this.nmid = '';
          this.qrisFile = null;
        }
      },
    },
    isHaveQRIS: {
      handler(val) {
        if (val == '0') {
          this.qrisFile = null;
          this.nmid = '';
        }
      },
    },

    noKTP: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.ktp_no != null &&
            val != this.errorValidation.ktp_no
          ) {
            this.$store.commit('daftarTugas/rm/clearErrorVariable', 'ktp_no');
          }
        }
      },
    },
    noNPWP: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.npwp_no != null &&
            val != this.errorValidation.npwp_no
          ) {
            this.$store.commit('daftarTugas/rm/clearErrorVariable', 'npwp_no');
          }
        }
        if (this.isCorporate && val.length === 15 && !val.startsWith('0')) {
          this.noNPWP = `0${val}`;
        }
      },
      immediate: true,
    },
    email: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.email != null &&
            val != this.errorValidation.email
          ) {
            this.$store.commit('daftarTugas/rm/clearErrorVariable', 'email');
          }
        }
      },
    },
    noRekening: {
      handler(val) {
        this.getValidateRek(val);

        if (this.errorValidation != null) {
          if (
            this.errorValidation.account_number != null &&
            val != this.errorValidation.account_number
          ) {
            this.$store.commit(
              'daftarTugas/rm/clearErrorVariable',
              'account_number'
            );
          }
        }
      },
    },
    noHandphone: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.mobile_phone != null &&
            val != this.errorValidation.mobile_phone
          ) {
            this.$store.commit(
              'daftarTugas/rm/clearErrorVariable',
              'mobile_phone'
            );
          }
        }
      },
    },
    noHandphoneMerchant: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.merchant_mobile_phone != null &&
            val != this.errorValidation.merchant_mobile_phone
          ) {
            this.$store.commit(
              'daftarTugas/rm/clearErrorVariable',
              'merchant_mobile_phone'
            );
          }
        }
      },
    },
    mid: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.mid != null &&
            val != this.errorValidation.mid
          ) {
            this.$store.commit('daftarTugas/rm/clearErrorVariable', 'mid');
          }
        }
      },
    },
    tid: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.tid != null &&
            val != this.errorValidation.tid
          ) {
            this.$store.commit('daftarTugas/rm/clearErrorVariable', 'tid');
          }
        }
      },
    },
    mdronus: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.mdr_on_us != null &&
            val != this.errorValidation.mdr_on_us
          ) {
            this.$store.commit(
              'daftarTugas/rm/clearErrorVariable',
              'mdr_on_us'
            );
          }
        }
      },
    },
    mdroffus: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.mdr_off_us != null &&
            val != this.errorValidation.mdr_off_us
          ) {
            this.$store.commit(
              'daftarTugas/rm/clearErrorVariable',
              'mdr_off_us'
            );
          }
        }
      },
    },
    searchKodepos: {
      handler(val) {
        if (val != null) {
          this.getDaerah();
        }
      },
    },
    searchownerPostalCode: {
      handler(val) {
        if (val != null) {
          this.getDaerahCustom(2);
        }
      },
    },

    merchantCriteria() {
      this.merchantCriteriaValue = this.merchantCriteria.value;
    },
    searchApprovalId1: {
      handler(val) {
        if (!this.approver1Loaded) return;
        // if (val != null) {
        clearTimeout(this.delayHitServiceA1);
        // if (this.namaKodepos) {
        this.delayHitServiceA1 = setTimeout(() => {
          this.getApprovalId1(this.listUserRoles[0].value, val);
        }, dataDelayServiceHit);
        // }
        // }
      },
    },
    searchApprovalId2: {
      handler(val) {
        if (!this.approver2Loaded) return;
        // if (val != null) {
        clearTimeout(this.delayHitServiceA2);
        // if (this.namaKodepos) {
        this.delayHitServiceA2 = setTimeout(() => {
          this.getApprovalId2(this.listUserRoles[1].value, val);
        }, dataDelayServiceHit);
        // }
        // }
      },
    },
    IDApprover1: {
      handler(val, oldVal) {
        if (val !== oldVal && this.errorValidation?.approver_1?.length > 0) {
          this.$store.commit(
            'daftarTugas/rm/clearErrorVariable',
            'approver_1'
          );
        }
      },
      deep: true,
    },
    IDApprover2: {
      handler(val, oldVal) {
        if (val !== oldVal && this.errorValidation?.approver_2?.length > 0) {
          this.$store.commit(
            'daftarTugas/rm/clearErrorVariable',
            'approver_2'
          );
        }
      },
      deep: true,
    },
    needInterface: {
      handler(val) {
        if (!val) {
          this.qrTypeInterface = [];
        }
      },
    },
    qrType: {
      handler(val) {
        const selectedQRText = this.qrItems.find((item) => item.value === val)?.text || '';
        if (!selectedQRText.includes('API')) {
          this.needInterface = false;
          this.qrTypeInterface = [];
        }
      },
    },
    isCPTS: {
      handler(val, oldVal) {
        if (oldVal === undefined) return;
        
        this.fetchDefaultMdrValues().then(() => {
          if (!this.isSpecialMdr) {
            if (this.defaultMdrOnUs && this.defaultMdrOffUs) {
              this.$store.commit('daftarTugas/rm/setMerchantVariable', {
                variable: 'mdr_on_us',
                payload: this.defaultMdrOnUs,
              });
              this.$store.commit('daftarTugas/rm/setMerchantVariable', {
                variable: 'mdr_off_us',
                payload: this.defaultMdrOffUs,
              });
            }
          }
        });
        
        this.$nextTick(() => {
          if (this.$v.mdronus) {
            this.$v.mdronus.$touch();
          }
          if (this.$v.mdroffus) {
            this.$v.mdroffus.$touch();
          }
        });
      },
    },
  },
  computed: {
    isCPTS() {
      return this.qrTypeInterface.includes('cpts');
    },
    pdfFileSK() {
      return `${window.location.origin}/assets/pdf/SK_Merchant_QRIS.pdf`;
    },
    errorValidation() {
      return this.$store.state.daftarTugas.rm.errors;
    },
    /**
     * Whether the last submission was rejected because of specific fields.
     *
     * Only a field-level rejection warrants scrolling to an input. A denied
     * permission, an expired session or a server fault leaves every field
     * valid, so scrolling would send the user hunting for an error that is not
     * there.
     *
     * @returns {boolean} True when at least one field carries an error.
     */
    hasFieldErrors() {
      const errors = this.errorValidation;
      if (errors == null || typeof errors !== 'object') return false;

      return Object.keys(errors).some(
        (field) => (errors[field] || []).length > 0
      );
    },
    data() {
      return this.$store.state.daftarTugas.rm.merchant;
    },
    isAdd() {
      if (this.data != null) {
        if (this.idTaskAdd.includes(this.data.task_type_id.toString())) {
          return true;
        }
      }
      return false;
    },
    isOutlet() {
      if (this.data != null) {
        if (this.data.task_type_id.toString() === '3') {
          return true;
        }
      }
      return false;
    },
    fieldInfoType() {
      if (this.isOutlet) {
        return this.isFromAggregator ? 'outletSubmerchant' : 'outletMerchant';
      }
      return 'submerchant';
    },
    isSubMerchant() {
      if (this.data == null) {
        return false;
      }
      return String(this.data.merchant_type_id) === '3';
    },
    isRegionalChainstoreOutlet() {
      if (this.data == null) {
        return false;
      }
      return this.data.is_chainstore === true;
    },
    isEdit() {
      if (this.data != null) {
        if (this.idTaskEdit.includes(this.data.task_type_id.toString())) {
          return true;
        }
      }
      return false;
    },
    isEditCloseMerchant() {
      return this.data != null && this.data.task_type_id.toString() == '7';
    },
    isEditBlockMerchant() {
      return this.data != null && this.data.task_type_id.toString() == '8';
    },
    isEditUnBlockMerchant() {
      return this.data != null && this.data.task_type_id.toString() == '9';
    },
    isEditResettlement() {
      return this.data != null && this.data.task_type_id.toString() == '14';
    },
    merchantTypeId() {
      if (this.data != null) {
        if (this.data.merchant_type_id != null) {
          return this.data.merchant_type_id;
        }
        return '1';
      }
      return '1';
    },
    accountType() {
      return this.data != null ? this.data.id_account_type : '1';
    },
    isCorporate() {
      return this.data != null ? this.data.id_account_type == '2' : true;
    },
    isFromAggregator() {
      return this.data != null ? this.data.id_aggregator != null : false;
    },
    isSubMerchantOrOutlet() {
      return this.isSubMerchant || this.isOutlet;
    },
    isRegionalSubMerchantOrOutlet() {
      return this.isSubMerchant || this.isRegionalChainstoreOutlet;
    },
    isReferralCodeDisabled() {
      if (this.isAdd) {
        return false;
      }
      if (this.isEdit && !this.isUpdatePTEN) {
        return true;
      }
      return true;
    },
    isRegionalReferralCodeDisabled() {
      if (this.isAdd) {
        return false;
      }
      return true;
    },
    isImageDokumen() {
      return this.data != null
        ? !!(this.data.image_ktp != null || this.data.image_lokasi != null)
        : false;
    },
    itemsAreaCode() {
      return this.$store.state.master.daerah.list.areaCode;
    },
    itemsKodepos() {
      return this.$store.state.master.daerah.list.kodepos;
    },
    itemsKodeposOwner() {
      return this.$store.state.master.daerah.list.kodeposOwner;
    },
    itemsJenisUsaha() {
      return this.$store.state.master.daerah.list.jenisUsaha;
    },
    listMerchantModel() {
      return listMerchantModel;
    },
    itemsApprovalId1() {
      const storeList = this.$store.state.master.daerah.list.approvalId1;
      
      if (storeList.length === 0 && this.data && this.data.approver_1_id) {
        return [{
          id: this.data.approver_1_id,
          username: this.data.approver_1,
          user_id: this.data.approver_1_id,
        }];
      }
      
      const list = storeList.find(
        (a) =>
          a.user_id ==
          JSON.parse(localStorage.getItem('logged_in_qram')).user.id
      );
      return list != undefined
        ? [list]
        : storeList;
    },
    itemsApprovalId2() {
      const storeList = this.$store.state.master.daerah.list.approvalId2;
      
      if (storeList.length === 0 && this.data && this.data.approver_2_id) {
        return [{
          id: this.data.approver_2_id,
          username: this.data.approver_2,
          user_id: this.data.approver_2_id,
        }];
      }
      
      return storeList;
    },
    merchantPhone() {
      const area =
        this.data.phone_area_code != '' && this.data.phone_area_code != null
          ? `(${this.data.phone_area_code})`
          : '';
      const phone = this.data.phone != null ? this.data.phone : '';
      return `${area} ${phone}`;
    },
    accountTypeField: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'id_account_type',
          payload: val,
        });
      },
      get() {
        if (this.data != null) {
          if (this.data.id_account_type != undefined) {
            return this.data.id_account_type.toString();
          }
        }
        return '';
      },
    },
    qrType: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'id_qr_type',
          payload: val,
        });
      },
      get() {
        if (this.data != null) {
          if (this.data.id_qr_type != undefined) {
            return this.data.id_qr_type.toString();
          }
        }
        return '';
      },
    },
    noHandphone: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'mobile_phone',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.mobile_phone;
      },
    },
    noHandphoneMerchant: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'merchant_mobile_phone',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.merchant_mobile_phone;
      },
    },
    companyName: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'company_name',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.company_name;
      },
    },
    merchantName: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'merchant_name',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.merchant_name;
      },
    },
    merchantOwnerName: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'owner_name',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.owner_name;
      },
    },
    noRekening: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'account_number',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.account_number;
      },
    },
    noKTP: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'ktp_no',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.ktp_no;
      },
    },
    noNPWP: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'npwp_no',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.npwp_no;
      },
    },
    email: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'email',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.email;
      },
    },
    areaCode: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'phone_area_code',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.phone_area_code;
      },
    },
    noTelpMerchant: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'phone',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.phone;
      },
    },
    jenisUsaha: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'mcc_id',
          payload: val != null ? val.mcc : '',
        });
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'mcc_name',
          payload: val != null ? val.mcc_name : '',
        });

        setTimeout(() => {
          this.showMDR();
        }, 0);
      },
      get() {
        let resVal = '';

        if (this.data != null)
          resVal = {
            mcc_id: this.data.mcc_id,
            mcc_name: this.data.mcc_name,
          };

        return resVal;
      },
    },
    mdronus: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'mdr_on_us',
          payload: val,
        });
      },
      get() {
        if (this.isEdit && this.isUpdatePTEN && this.ptenMdrOnUs !== '') {
          return this.ptenMdrOnUs;
        }
        return this.data == null ? '' : this.data.mdr_on_us;
      },
    },
    mdroffus: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'mdr_off_us',
          payload: val,
        });
      },
      get() {
        if (this.isEdit && this.isUpdatePTEN && this.ptenMdrOffUs !== '') {
          return this.ptenMdrOffUs;
        }
        return this.data == null ? '' : this.data.mdr_off_us;
      },
    },
    merchantCriteria: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'merchant_criteria_id',
          payload: val.value,
        });

        setTimeout(() => {
          this.showMDR();
        }, 0);
      },
      get() {
        return this.data == null
          ? ''
          : this.listCriteria.find(
            (a) => a.value == this.data.merchant_criteria_id
          );
      },
    },
    alamatMerchant: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'address',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.address;
      },
    },
    kodepos: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'kode_pos',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.kode_pos;
      },
    },
    endpoint: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'endpoint',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.endpoint;
      },
    },
    ipAddress: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'ip_address',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.ip_address;
      },
    },
    IDApprover1: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'approver_1_id',
          payload: val == null ? '' : val.user_id,
        });
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'approver_1',
          payload: val == null ? '' : val.username,
        });
      },
      get() {
        if (this.data != null && this.data.approver_1_id) {
          return {
            id: this.data.approver_1_id,
            username: this.data.approver_1,
          };
        }
        return '';
      },
    },
    IDApprover2: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'approver_2_id',
          payload: val == null ? '' : val.user_id,
        });
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'approver_2',
          payload: val == null ? '' : val.username,
        });
      },
      get() {
        if (this.data != null && this.data.approver_2_id) {
          return {
            id: this.data.approver_2_id,
            username: this.data.approver_2,
          };
        }
        return '';
      },
    },
    nmid: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'nmid',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.nmid;
      },
    },
    mpan: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'mpan',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.mpan;
      },
    },
    mid: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'mid',
          payload: val,
        });
      },
      get() {
        if (this.data != null) {
          if (this.data.mid != undefined) {
            return this.data.mid.toString();
          }
        }
        return '';
      },
    },
    tid: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'tid',
          payload: val,
        });
      },
      get() {
        if (this.data != null) {
          if (this.data.tid != undefined) {
            return this.data.tid.toString();
          }
        }
        return '';
      },
    },
    ownerCityofBirth: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'owner_city_of_birth',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.owner_city_of_birth;
      },
    },
    ownerDateofBirth: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'owner_date_of_birth',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.owner_date_of_birth;
      },
    },
    ownerAddress: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'owner_address',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.owner_address;
      },
    },
    ownerPostalCode: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'kode_pos_additional',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.kode_pos_additional;
      },
    },
    accountHolderName: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'account_holder_name',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.account_holder_name;
      },
    },
    bniBranchOffice: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'bni_branch_office',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.bni_branch_office;
      },
    },
    merchantEstSince: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'merchant_est_since',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.merchant_est_since;
      },
    },
    merchantEmail: {
      set(val) {
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'merchant_email',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.merchant_email;
      },
    },
    invalidQRIS() {
      return this.$store.state.register.qrisError;
    },
    OnValidateQRIS() {
      return this.$store.state.register.OnValidateQRIS;
    },
    previewQrisFile() {
      let resVal = false;

      if (this.qrisFile) {
        resVal = URL.createObjectURL(this.qrisFile);
      }
      return resVal;
    },
    qrItemsFiltered() {
      return this.accountTypeField == '1' ? this.individuQR : this.corporateQR;
    },
    qrItems() {
      return this.accountTypeField == '1'
        ? this.listQRTypeIndividu
        : this.listQrType;
    },

    namaJenisUsaha() {
      return this.jenisUsaha == null ? '' : this.jenisUsaha.mcc_name;
    },
    namaCriteriaMerchant() {
      return this.merchantCriteria == null ? '' : this.merchantCriteria.text;
    },
    noHandphoneErrors() {
      const errors = [];
      if (!this.$v.noHandphone.$dirty) return errors;
      if (!this.$v.noHandphone.required)
        errors.push('No Handphone is required');
      if (!this.$v.noHandphone.numeric) errors.push('Must be numeric');
      if (!this.$v.noHandphone.maxLength)
        errors.push('No Handphone max digit is 15');
      if (!this.$v.noHandphone.isUnique) {
        if (this.errorValidation.mobile_phone != null) {
          this.errorValidation.mobile_phone.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    noHandphoneMerchantErrors() {
      const errors = [];
      if (!this.$v.noHandphoneMerchant.$dirty) return errors;
      if (!this.$v.noHandphoneMerchant.required)
        errors.push('No Handphone Merchant is required');
      if (!this.$v.noHandphoneMerchant.numeric) errors.push('Must be numeric');
      if (!this.$v.noHandphoneMerchant.maxLength)
        errors.push('No Handphone Merchant max digit is 15');
      if (!this.$v.noHandphoneMerchant.isUnique) {
        if (this.errorValidation.merchant_mobile_phone != null) {
          this.errorValidation.merchant_mobile_phone.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    accountTypeFieldErrors() {
      const errors = [];
      if (!this.$v.accountTypeField.$dirty) return errors;
      if (!this.$v.accountTypeField.required)
        errors.push('Tipe Merchant is required');
      return errors;
    },

    qrTypeErrors() {
      const errors = [];
      if (!this.$v.qrType.$dirty) return errors;
      if (!this.$v.qrType.required) errors.push('QR Type is required');
      return errors;
    },

    channelQrFiltered() {
      const channelQrTypeMapping = {
        '1': ['000', '521', '600'],
        '2': ['400', '401', '521', '600'],
        '3': ['400', '600'],
        '4': ['000', '521', '600', '400', '401'],
        '5': ['000', '521', '600', '400', '401'],
        '6': ['000', '400', '521', '600'],
        '7': ['400', '401', '521', '600'],
        '8': [],
      };
      const allowedChannels = channelQrTypeMapping[String(this.qrType)] || [];
      return this.$store.state.register.channelQrList.filter(
        (item) => allowedChannels.includes(item.code)
      );
    },

    channelQrErrors() {
      const errors = [];
      if (!this.$v.channelQr.$dirty) return errors;
      if (!this.$v.channelQr.required) errors.push('Channel QR is required');
      return errors;
    },

    merchantModelErrors() {
      const errors = [];
      if (!this.$v.merchantModel.$dirty) return errors;
      if (!this.$v.merchantModel.required) errors.push('Model Usaha is required');
      return errors;
    },

    isQrTypeWithAPI() {
      const apiQrValues = ['2', '4', '5', '7'];
      return apiQrValues.includes(this.qrType);
    },

    endpointErrors() {
      const errors = [];
      if (!this.$v.endpoint.$dirty) return errors;
      if (!this.$v.endpoint.url) errors.push('URL not valid');
      return errors;
    },

    ipAddressErrors() {
      const errors = [];
      if (!this.$v.ipAddress.$dirty) return errors;
      if (!this.$v.ipAddress.customValidation)
        errors.push('Must be a valid IP Address');
      return errors;
    },

    companyNameErrors() {
      const errors = [];
      if (!this.$v.companyName.$dirty) return errors;
      if (!this.$v.companyName.required)
        errors.push('Nama Perusahaan is required');
      if (!this.$v.companyName.alphanumChar)
        errors.push(`Valid character are A-z, 0-9, and (*)`);

      return errors;
    },

    typeMerchant() {
      return this.merchantTypeId == 1 ? 'Merchant' : 'Sub Merchant';
    },
    merchantNameErrors() {
      const errors = [];
      const csLewisMerchant = this.merchantName?.toLowerCase();
      const criteriaRegex = [
        /spbu/,
        /pertamina/,
        /pertamini/,
        /petrolium/,
        /gas/,
        /spbg/,
        /spba/,
      ];
      const garudaRegex = [/garuda/];

      const isRequiredSpbu = [5541, 5542, 5172, 5983].includes(
        parseInt(this.jenisUsaha?.mcc_id, 10)
      );
      const isRequiredGaruda = parseInt(this.jenisUsaha?.mcc_id, 10) === 3103;

      const criteriaError = this.checkCriteria(
        csLewisMerchant,
        criteriaRegex,
        `Nama ${this.typeMerchant} harus mengandung salah satu dari: SPBU, SPBA, SPBG, Pertamina, Pertamini, Petrolium, Gas`,
        isRequiredSpbu
      );

      const garudaError = this.checkCriteria(
        csLewisMerchant,
        garudaRegex,
        `Nama ${this.typeMerchant} harus mengandung kata: Garuda`,
        isRequiredGaruda
      );

      const alphanumericError = this.checkAlphanumeric();
      const numberValidationError = this.checkNumberValidate();
      const requiredError = this.checkRequired();

      if (criteriaError) errors.push(criteriaError);
      if (garudaError) errors.push(garudaError);
      if (alphanumericError) errors.push(alphanumericError);
      if (numberValidationError) errors.push(numberValidationError);
      if (requiredError) errors.push(requiredError);

      return errors;
    },

    merchantOwnerNameErrors() {
      const errors = [];
      if (!this.$v.merchantOwnerName.$dirty) return errors;
      if (!this.$v.merchantOwnerName.required)
        errors.push('Nama Pemilik Usaha is required');
      if (!this.$v.merchantOwnerName.alphanumChar)
        errors.push(`Valid character are A-z, 0-9, and (*)`);

      return errors;
    },
    noRekeningErrors() {
      const errors = [];
      if (!this.$v.noRekening.$dirty) return errors;
      if (!this.$v.noRekening.required)
        errors.push('Nomor Rekening Perusahaan is required');
      if (!this.$v.noRekening.numeric) errors.push('Must be numeric');
      if (!this.$v.noRekening.isRekVc) errors.push('Must be 9-10 or 16 digits');
      if (!this.$v.noRekening.isUnique) {
        if (this.errorValidation.account_number != null) {
          this.errorValidation.account_number.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    noTelpMerchantErrors() {
      const errors = [];
      if (!this.$v.noTelpMerchant.$dirty) return errors;
      if (!this.$v.noTelpMerchant.numeric) errors.push('Must be numeric');
      return errors;
    },
    noKTPErrors() {
      const errors = [];
      if (!this.$v.noKTP.$dirty) return errors;
      if (!this.$v.noKTP.required) errors.push('KTP number is required');
      if (!this.$v.noKTP.numeric) errors.push('Must be numeric');
      if (!this.$v.noKTP.maxLength) errors.push('KTP number must be 16 digit');
      if (!this.$v.noKTP.minLength) errors.push('KTP number must be 16 digit');
      if (!this.$v.noKTP.isUnique) {
        if (this.errorValidation.ktp_no != null) {
          this.errorValidation.ktp_no.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    noNPWPErrors() {
      const errors = [];
      if (!this.$v.noNPWP.$dirty) return errors;
      if (!this.$v.noNPWP.required) errors.push('NPWP number is required');
      if (!this.$v.noNPWP.numeric) errors.push('Must be numeric');
      if (!this.$v.noNPWP.maxLength)
        errors.push('NPWP harus 16 digit, pastikan Anda mengisi data dengan benar!');
      if (!this.$v.noNPWP.minLength)
        errors.push('NPWP harus 16 digit, pastikan Anda mengisi data dengan benar!');
      if (!this.$v.noNPWP.isUnique) {
        if (this.errorValidation.npwp_no != null) {
          this.errorValidation.npwp_no.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email || !this.$v.email.doesNotContainPipe)
        errors.push('Must be valid e-mail');
      if (!this.$v.email.required) errors.push('Email is required');
      if (!this.$v.email.isUnique) {
        if (this.errorValidation.email != null) {
          this.errorValidation.email.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    jenisUsahaErrors() {
      const errors = [];
      if (!this.$v.jenisUsaha.$dirty) return errors;

      if (this.$v.jenisUsaha.$model != null) {
        const mccNot = this.$v.jenisUsaha.$model.mcc_id;
        const notApply = this.notApply(mccNot);
        if (!notApply) {
          //! this.$v.jenisUsaha.jenisUsahaChange
          errors.push(
            `Jenis Usaha ${this.$v.jenisUsaha.$model.mcc_name.toLowerCase()} does not apply`
          );
        }
      }

      if (!this.$v.jenisUsaha.required) errors.push('Jenis Usaha is required');
      return errors;
    },
    merchantCriteriaErrors() {
      const errors = [];

      const checkIsNotUbe = () => {
        const modelMcc = this.$v.jenisUsaha.$model?.mcc_id;
        const rangeMccQuote = this.rangeQuote(modelMcc);

        if (!rangeMccQuote && !this.$v.merchantCriteria.criteriaRange) {
          errors.push(
            'Kode jenis usaha 3500 sampai 3828 - merchant criteria mandatory for (UBE) Usaha Besar'
          );
        }
      };

      const checkIsUbe = () => {
        const modelMcc = this.merchantCriteriaValue;
        this.rangeQuote(modelMcc);
      };

      const checkIsNotUre = () => {
        const quoteMcc = this.$v.jenisUsaha.$model?.mcc_id;
        const quoteCriteria = this.rangeQuoteUre(quoteMcc);

        if (!quoteCriteria && !this.$v.merchantCriteria.criteriaUre) {
          errors.push('Merchant criteria mandatory for (URE) Usaha Reguler');
        }
      };

      const checkIsUre = () => {
        const modelMcc = this.merchantCriteriaValue;
        this.rangeQuoteUre(modelMcc);
      };

      const isUbe = this.merchantCriteriaValue === 'UBE';
      const isUre = this.merchantCriteriaValue === 'URE';

      if (!isUbe && this.$v.jenisUsaha.$model) {
        checkIsNotUbe();
      } else if (isUbe) {
        checkIsUbe();
      }

      if (!isUre && this.$v.jenisUsaha.$model) {
        checkIsNotUre();
      } else if (isUre) {
        checkIsUre();
      }

      if (
        this.$v.merchantCriteria.$dirty &&
        !this.$v.merchantCriteria.required
      ) {
        errors.push('Merchant Criteria is required');
      }

      return errors;
    },
    IDApprover1Errors() {
      const errors = [];
      if (!this.$v.IDApprover1.$dirty) return errors;
      if (!this.$v.IDApprover1.required)
        errors.push('ID Approver 1 is required');
      if (!this.$v.IDApprover1.isUnique) {
        if (this.errorValidation.approver_1 != null) {
          this.errorValidation.approver_1.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    IDApprover2Errors() {
      const errors = [];
      if (!this.$v.IDApprover2.$dirty) return errors;
      if (!this.$v.IDApprover2.required)
        errors.push('ID Approver 2 is required');
      if (!this.$v.IDApprover2.isUnique) {
        if (this.errorValidation.approver_2 != null) {
          this.errorValidation.approver_2.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    alamatMerchantErrors() {
      const errors = [];
      if (!this.$v.alamatMerchant.$dirty) return errors;
      if (!this.$v.alamatMerchant.required)
        errors.push('Alamat Merchant is required');
      if (!this.$v.alamatMerchant.doesNotContainPipe)
        errors.push(`Character is not allowed`);

      return errors;
    },
    kodeposErrors() {
      const errors = [];
      if (!this.$v.kodepos.$dirty) return errors;
      if (!this.$v.kodepos.required) errors.push('Kode Pos is required');
      return errors;
    },
    nmidErrors() {
      let errors = [];
      if (!this.$v.nmid.$dirty) errors = [];
      return errors;
    },
    remarkErrors() {
      const errors = [];
      if (!this.$v.remark.$dirty) return errors;
      if (!this.$v.remark.required) errors.push('Remark is required!');
      return errors;
    },
    remarkPTENErrors() {
      const errors = [];
      if (!this.$v.remarkPTEN.$dirty) return errors;
      if (!this.$v.remarkPTEN.required) errors.push('Remark is required!');
      if (!this.$v.remarkPTEN.maxLength)
        errors.push(`Remark maximum ${this.remarkPTENMaxLength} character`);
      if (!this.$v.remarkPTEN.minLength)
        errors.push(`Remark minimum ${this.remarkPTENMinLength} character`);
      return errors;
    },
    reasonErrors() {
      const errors = [];
      if (!this.$v.reason.$dirty) return errors;
      if (!this.$v.reason.required) errors.push('Reason is required');
      if (!this.$v.reason.maxLength)
        errors.push('Reason must be less then 50 digit');
      if (!this.$v.reason.minLength)
        errors.push('Reason must be more then 5 digit');
      return errors;
    },
    mdronusErrors() {
      const errors = [];
      if (!this.$v.mdronus.$dirty) return errors;
      let maxValue = process.env.VUE_APP_MAX_MDR;
      if (this.isCPTS) {
        const merchantId = String(this.merchantTypeId);
        maxValue = merchantId === '1' 
          ? dataCptsMdrValues.merchant.mdr_on_us 
          : dataCptsMdrValues.sub_merchant.mdr_on_us;
      }
      if (!this.$v.mdronus.minVal)
        errors.push(`Minimal value is ${process.env.VUE_APP_MIN_MDR}!`);
      if (!this.$v.mdronus.maxVal)
        errors.push(`Maximal value is ${maxValue}!`);
      if (!this.$v.mdronus.required) errors.push('MDR On Us is required!');
      if (!this.$v.mdronus.numericDecimal)
        errors.push('MDR On Us is numeric only');
      if (!this.$v.mdronus.isValidMdr) {
        if (this.errorValidation.mdr_on_us != null) {
          this.errorValidation.mdr_on_us.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    mdroffusErrors() {
      const errors = [];
      if (!this.$v.mdroffus.$dirty) return errors;
      let maxValue = process.env.VUE_APP_MAX_MDR;
      if (this.isCPTS) {
        const merchantId = String(this.merchantTypeId);
        maxValue = merchantId === '1' 
          ? dataCptsMdrValues.merchant.mdr_off_us 
          : dataCptsMdrValues.sub_merchant.mdr_off_us;
      }
      if (!this.$v.mdroffus.minVal)
        errors.push(`Minimal value is ${process.env.VUE_APP_MIN_MDR}!`);
      if (!this.$v.mdroffus.maxVal)
        errors.push(`Maximal value is ${maxValue}!`);
      if (!this.$v.mdroffus.required) errors.push('MDR Off Us is required!');
      if (!this.$v.mdroffus.numericDecimal)
        errors.push('MDR Off Us is numeric only');
      if (!this.$v.mdroffus.isValidMdr) {
        if (this.errorValidation.mdr_off_us != null) {
          this.errorValidation.mdr_off_us.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    mdrFileErrors() {
      const errors = [];
      if (!this.$v.mdrFile.$dirty) return errors;
      if (!this.$v.mdrFile.required) errors.push('Dokumen MDR Khusus is Required!');
      if (!this.$v.mdrFile.maxSize) {
        errors.push('File size must not exceed 1 MB.');
      }
      if (!this.$v.mdrFile.fileType) {
        errors.push('Invalid file type. Allowed format: PDF');
      }
      return errors;
    },
    skErrors() {
      const errors = [];
      if (!this.$v.sk.$dirty) return errors;
      if (!this.$v.sk.required) errors.push('S&K is required');
      return errors;
    },
    tidErrors() {
      let errors = [];
      if (!this.$v.tid.$dirty) errors = [];
      return errors;
    },
    midErrors() {
      const errors = [];
      if (!this.$v.mid.$dirty) return errors;
      if (!this.$v.mid.required) errors.push('MID is required');
      if (!this.$v.mid.minLength)
        errors.push(`MID must be at least ${this.midMinLength} digit`);
      if (!this.$v.mid.maxLength)
        errors.push(`MID can't more than ${this.midMaxLength} digit`);
      if (!this.$v.mid.numeric) errors.push('Must be numeric');
      if (!this.$v.mid.isUnique) {
        if (this.errorValidation.mid != null) {
          this.errorValidation.mid.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    mpanErrors() {
      let errors = [];
      if (!this.$v.mid.$dirty) errors = [];
      return errors;
    },
    isUpdatePTEN() {
      if (this.data != null) {
        if (this.data.task_type_id.toString() == '4') {
          return true;
        }
        if (this.data.task_type_id.toString() == '5') {
          return false;
        }
      }
      return false;
    },

    merchantEstSinceErrors() {
      const errors = [];
      if (!this.$v.merchantEstSince.$dirty) return errors;
      if (!this.$v.merchantEstSince.numeric) errors.push('Must be numeric');
      return errors;
    },
    merchantEmailErrors() {
      const errors = [];
      if (!this.$v.merchantEmail.$dirty) return errors;
      if (
        !this.$v.merchantEmail.email ||
        !this.$v.merchantEmail.doesNotContainPipe
      )
        errors.push('Must be valid e-mail');

      return errors;
    },
    showMDRForm: {
      set(val) {
        this.getMDR(val);
      },
      get() {
        return (
          !this.isEdit &&
          this.jenisUsaha.mcc_id != null &&
          this.jenisUsaha.mcc_id != '' &&
          this.merchantCriteria
        );
      },
    },
    namaKodepos() {
      return this.getNamaDaerah('kodepos', this.kodepos);
    },
  },
  beforeDestroy() {
    if (this.ptenMdrTimeout) {
      clearTimeout(this.ptenMdrTimeout);
    }
  },
  methods: {
    onMdrFileChange(file) {
      this.mdrFile = file;
      this.$v.mdrFile.$touch();
    },
    onMdrFileRemove() {
      this.mdrFile = null;
      this.$v.mdrFile.$reset();
    },
    checkCriteria(csLewisMerchant, regex, errorMessage, isRequired) {
      if (
        this.jenisUsaha &&
        isRequired &&
        !this.matchInArray(csLewisMerchant, regex) &&
        !this.$v.merchantName.merchantCriteriaMcc
      ) {
        return errorMessage;
      }
      return null;
    },
    checkAlphanumeric() {
      if (this.merchantName && !this.$v.merchantName.alphanumChar) {
        return `Valid character are A-z, 0-9, and (*)`;
      }
      return null;
    },

    copyNoKTPtoNPWP() {
      this.noNPWP = this.noKTP;
    },
    checkNumberValidate() {
      if (this.merchantName && !this.$v.merchantName.numberValidate) {
        return `Nama ${this.typeMerchant} cannot be all numbers`;
      }
      return null;
    },
    checkRequired() {
      if (this.$v.merchantName.$dirty && !this.$v.merchantName.required) {
        return `Nama ${this.typeMerchant} is required`;
      }
      return null;
    },

    showMDR() {
      if (
        !this.isEdit &&
        this.jenisUsaha.mcc_id != null &&
        this.jenisUsaha.mcc_id != '' &&
        this.merchantCriteria
      ) {
        this.showMDRForm = true;
      } else {
        this.showMDRForm = false;
      }
      
      if (
        this.isEdit &&
        this.isUpdatePTEN &&
        this.jenisUsaha.mcc_id != null &&
        this.jenisUsaha.mcc_id != '' &&
        this.merchantCriteria &&
        this.merchantCriteria.value
      ) {
        if (!this.isInitialLoad && !this.isSpecialMdr) {
          if (this.ptenMdrTimeout) {
            clearTimeout(this.ptenMdrTimeout);
          }
          this.ptenMdrTimeout = setTimeout(() => {
            this.getPtenMdrValues();
          }, 300);
        }
      }
    },

    matchInArray(csLewisMerhant = null, regexQuote = null) {
      if (csLewisMerhant && regexQuote != null) {
        const len = regexQuote.length;
        for (let i = 0; i < len; i += 1) {
          if (csLewisMerhant.match(regexQuote[i])) {
            this.criteriaQuote = true;
            return true;
          }
        }
        this.criteriaQuote = false;
        return false;
      }
      this.criteriaQuote = true;
      return true;
    },

    notApply(mccNot) {
      if (mccNot == 5598 || mccNot == 2222) {
        this.jenisUsahaQuote = false;
        this.criteriaQuote = true;
        return false;
      }
      this.criteriaQuote = true;
      this.jenisUsahaQuote = true;
      return true;
    },

    rangeQuote(mccCriteria) {
      if (mccCriteria == 'UBE') {
        this.rangeUbe = true;
        return true;
      }
      if (mccCriteria >= 3500 && mccCriteria <= 3828) {
        this.rangeUbe = false;
        return false;
      }
      this.rangeUbe = true;
      return true;
    },

    rangeQuoteUre(mccCriteria) {
      if (mccCriteria == 'URE') {
        this.rangeUre = true;
        return true;
      }
      if (mccCriteria == 8661 || mccCriteria == 8398) {
        this.rangeUre = false;
        return false;
      }
      this.rangeUre = true;
      return true;
    },

    getMDR(val) {
      if (val) {
        if (this.isCPTS) {
          const merchantId = String(this.merchantTypeId);
          const mdrValues = merchantId === '1' 
            ? dataCptsMdrValues.merchant 
            : dataCptsMdrValues.sub_merchant;
          
          const onUs = mdrValues.mdr_on_us.toString();
          const offUs = mdrValues.mdr_off_us.toString();
          
          // Update default values so they reflect the current criteria
          this.defaultMdrOnUs = onUs;
          this.defaultMdrOffUs = offUs;
          
          // Only update actual values if not using special MDR
          if (!this.isSpecialMdr) {
            this.$store.commit('daftarTugas/rm/setMerchantVariable', {
              variable: 'mdr_on_us',
              payload: onUs,
            });
            this.$store.commit('daftarTugas/rm/setMerchantVariable', {
              variable: 'mdr_off_us',
              payload: offUs,
            });
          }
          return;
        }

        this.loadingMdr = true;
        this.$store
          .dispatch('register/getMdrList', {
            mcc: this.jenisUsaha.mcc_id,
            merchant_criteria: this.merchantCriteria.value,
            date,
          })
          .then((res) => {
            if (res) {
              const onUs = res.mdr_on_us ?? '';
              const offUs = res.mdr_off_us ?? '';
              
              this.defaultMdrOnUs = onUs;
              this.defaultMdrOffUs = offUs;
              
              if (!this.isSpecialMdr) {
                this.$store.commit('daftarTugas/rm/setMerchantVariable', {
                  variable: 'mdr_on_us',
                  payload: onUs,
                });
                this.$store.commit('daftarTugas/rm/setMerchantVariable', {
                  variable: 'mdr_off_us',
                  payload: offUs,
                });
              }
            }
          })
          .finally(() => {
            this.loadingMdr = false;
          });
      } else {
        // Don't reset MDR values for Edit PTEN case
        if (this.isEdit && this.isUpdatePTEN) {
          return;
        }
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'mdr_on_us',
          payload: '',
        });
        this.$store.commit('daftarTugas/rm/setMerchantVariable', {
          variable: 'mdr_off_us',
          payload: '',
        });
      }
    },

    async checkCustomMdrStatus() {
      if (this.data?.custom_mdr_id && this.data?.custom_mdr_filename) {
        await this.fetchDefaultMdrValues();
        this.isSpecialMdr = true;
        
        await this.loadExistingMdrFile();
        return;
      }
      
      const detailMdrOnUs = parseFloat(this.originalDetailMdrOnUs) || 0;
      const detailMdrOffUs = parseFloat(this.originalDetailMdrOffUs) || 0;

      const isCptsType = this.data?.qr_type_interface?.includes('cpts');
      
      if (isCptsType) {
        const merchantId = String(this.merchantTypeId);
        const cptsMdrValues = merchantId === '1' 
          ? dataCptsMdrValues.merchant 
          : dataCptsMdrValues.sub_merchant;
        
        const defaultOnUs = parseFloat(cptsMdrValues.mdr_on_us) || 0;
        const defaultOffUs = parseFloat(cptsMdrValues.mdr_off_us) || 0;

        this.defaultMdrOnUs = cptsMdrValues.mdr_on_us?.toString() || '';
        this.defaultMdrOffUs = cptsMdrValues.mdr_off_us?.toString() || '';

        if (detailMdrOnUs !== defaultOnUs || detailMdrOffUs !== defaultOffUs) {
          this.isSpecialMdr = true;
        }
        return;
      }

      if (this.data?.mcc_id && this.data?.merchant_criteria_id) {
        try {
          const res = await this.$store.dispatch('register/getMdrList', {
            mcc: this.data.mcc_id,
            merchant_criteria: this.data.merchant_criteria_id,
            date,
          });

          if (res) {
            const defaultOnUs = parseFloat(res.mdr_on_us) || 0;
            const defaultOffUs = parseFloat(res.mdr_off_us) || 0;

            this.defaultMdrOnUs = res.mdr_on_us?.toString() || '';
            this.defaultMdrOffUs = res.mdr_off_us?.toString() || '';

            if (detailMdrOnUs !== defaultOnUs || detailMdrOffUs !== defaultOffUs) {
              this.isSpecialMdr = true;
            }
          }
        } catch (error) {
          console.error('Error checking custom MDR status:', error);
        }
      }
    },

    async fetchDefaultMdrValues() {
      const isCptsType = this.isCPTS || this.data?.qr_type_interface?.includes('cpts');
      
      if (isCptsType) {
        const merchantId = String(this.merchantTypeId);
        const cptsMdrValues = merchantId === '1' 
          ? dataCptsMdrValues.merchant 
          : dataCptsMdrValues.sub_merchant;
        
        this.defaultMdrOnUs = cptsMdrValues.mdr_on_us?.toString() || '';
        this.defaultMdrOffUs = cptsMdrValues.mdr_off_us?.toString() || '';
        return;
      }
      const mccId = this.jenisUsaha?.mcc_id || this.data?.mcc_id;
      const criteriaId = this.merchantCriteria?.value || this.data?.merchant_criteria_id;
      
      if (mccId && criteriaId) {
        try {
          const res = await this.$store.dispatch('register/getMdrList', {
            mcc: mccId,
            merchant_criteria: criteriaId,
            date,
          });

          if (res) {
            this.defaultMdrOnUs = res.mdr_on_us?.toString() || '';
            this.defaultMdrOffUs = res.mdr_off_us?.toString() || '';
          }
        } catch (error) {
          console.error('Error fetching default MDR values:', error);
        }
      }
    },

    async loadExistingMdrFile() {
      try {
        const result = await this.$store.dispatch('mdrFile/getMdrFileAsFile', {
          documentId: this.data.custom_mdr_id,
          type: 'new',
          filename: this.data.custom_mdr_filename,
        });

        if (result.success && result.file) {
          this.mdrFile = result.file;
        }
      } catch (error) {
        console.error('Error loading existing MDR file:', error);
      }
    },

    previewMdrFile() {
      if (!this.mdrFile) return;
      
      const fileUrl = URL.createObjectURL(this.mdrFile);
      window.open(fileUrl, '_blank');
      
      setTimeout(() => {
        URL.revokeObjectURL(fileUrl);
      }, 1000);
    },

    downloadMdrFile() {
      if (!this.mdrFile) return;
      
      const fileUrl = URL.createObjectURL(this.mdrFile);
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = this.mdrFile.name || 'dokumen_mdr_khusus.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(fileUrl);
    },

    async getValidateRek(val) {
      this.isloadingRekening = true;
      this.$store
        .dispatch('daftarTugas/rm/validate', {
          date,
          no_rekening: val,
        })
        .then(() => {
          this.isloadingRekening = false;
        });
    },

    customFilter(item, queryText) {
      const textOne = item.mcc_name.toLowerCase();
      const textTwo = item.mcc.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },

    printThePDF(pdfVal) {
      try {
        printJS(pdfVal);
      } catch (error) {
        console.error('Error printing PDF:', error);
      }
    },

    getNamaDaerah(category, kodePos) {
      if (kodePos != null) {
        let nama = '';
        const splitDaerah = kodePos.split(', ');

        const [kelurahan, kecamatan, kabupaten, provinsi, kodepos] =
          splitDaerah;
        switch (category) {
          case 'kodepos':
            nama = kodepos;
            break;
          case 'provinsi':
            nama = provinsi;
            break;
          case 'kabupaten':
            nama = kabupaten;
            break;
          case 'kecamatan':
            nama = kecamatan;
            break;
          case 'kelurahan':
            nama = kelurahan;
            break;
          default:
            break;
        }
        return nama;
      }
      return '';
    },

    async getDaerah() {
      this.isLoadingKodepos = true;
      await this.$store
        .dispatch('master/daerah/list/getDaerah', {
          query: this.searchKodepos == null ? '' : this.searchKodepos,
        })
        .finally(() => {
          this.isLoadingKodepos = false;
        });
    },

    async getDaerahCustom(type) {
      let typeQuery;
      let typeDataOwner;

      if (type == 1) {
        typeQuery = this.searchKodepos == null ? '' : this.searchKodepos;
        typeDataOwner = false;
      } else {
        typeQuery =
          this.searchownerPostalCode == null ? '' : this.searchownerPostalCode;
        typeDataOwner = 'owner';
      }

      this.isLoadingownerPostalCode = true;
      await this.$store
        .dispatch('master/daerah/list/getDaerahCustom', {
          query: typeQuery,
          typeData: typeDataOwner,
        })
        .finally(() => {
          this.isLoadingownerPostalCode = false;
        });
    },

    async getAreaCode() {
      this.isLoadingAreaCode = true;
      await this.$store
        .dispatch('master/daerah/list/getAreaCode', {
          date,
          query: this.searchAreaCode,
        })
        .finally(() => {
          this.isLoadingAreaCode = false;
        });
    },

    async getJenisUsaha() {
      this.isLoadingJenisUsaha = true;
      await this.$store
        .dispatch('master/daerah/list/getJenisUsaha', {
          date,
          searchName:
            this.searchJenisUsaha == null ? '' : this.searchJenisUsaha,
        })
        .finally(() => {
          this.isLoadingJenisUsaha = false;
        });
    },

    async getDetailData() {
      this.loading = true;
      this.isInitialLoad = true;

      await this.$store
        .dispatch('daftarTugas/rm/viewMerchant', {
          id: this.$route.params.id,
          date,
          isPageUpdate: this.isPageUpdate,
        })
        .then(async () => {
          this.originalDetailMdrOnUs = this.data.mdr_on_us;
          this.originalDetailMdrOffUs = this.data.mdr_off_us;
          
          this.searchKodepos = this.data.kode_pos;
          this.kodepos = this.data.kode_pos;
          this.searchownerPostalCode = this.data.kode_pos_additional;
          this.ownerPostalCode = this.data.kode_pos_additional;
          this.searchJenisUsaha = this.data.mcc_name;
          if (!this.isUpdatePTEN) {
            this.setRegionalMappingFromDetail();
          }
          this.endpoint =
            this.data.endpoint == undefined ? '' : this.data.endpoint;
          if (this.data.channel_qr) {
            const channelQrCode = this.data.channel_qr.split(' - ')[0].trim();
            this.channelQr = channelQrCode;
          }
          if (this.data.merchant_model) {
            const model = listMerchantModel.find(
              (m) => m.text === this.data.merchant_model
            );
            this.merchantModel = model ? model.value : '';
          }
          if (this.data.qr_type_interface && this.data.qr_type_interface.length > 0) {
            this.needInterface = true;
            this.qrTypeInterface = this.data.qr_type_interface;
          } else {
            this.needInterface = false;
            this.qrTypeInterface = [];
          }
          this.loadChannelQrList();
          
          await this.checkCustomMdrStatus();
          
          if (
            this.data.id_aggregator != undefined &&
            this.data.id_aggregator != null
          ) {
            this.getDataAggregator();
          }
          
          this.$nextTick(() => {
            this.isInitialLoad = false;
          });
        })
        .catch(() => {
          this.$router.back();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getDataAggregator() {
      this.$store
        .dispatch('register/getDataAutofill', {
          date,
          id_merchant: '',
          id_aggregator: this.data.id_aggregator,
        })
        .then((res) => {
          if (res) {
            if (res.aggregator != null) {
              const filteredQR = qrByMerchantType(
                res.aggregator.qr_type == null
                  ? ''
                  : res.aggregator.qr_type.toString()
              );
              this.individuQR = filteredQR.individu;
              this.corporateQR = filteredQR.corporate;
            }
          }
        });
    },

    async loadChannelQrList() {
      if (this.$store.state.register.channelQrList.length > 0) {
        return;
      }
      this.isLoadingChannelQR = true;
      try {
        await this.$store.dispatch('register/getQRChannelList', {
          date,
        });
      } catch (error) {
        console.error('Error loading channel QR list:', error);
      } finally {
        this.isLoadingChannelQR = false;
      }
    },

    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:([^;]+);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      // eslint-disable-next-line no-plusplus
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    async checkQRIS() {
      const qrisIndex = this.allFile.findIndex((x) => x.doc_type == '4');
      if (qrisIndex != -1) this.allFile.splice(qrisIndex, 1);
      this.$store.commit('register/setQrisError', false);
      if (this.qrisFile) {
        await this.$store
          .dispatch('register/uploadDocument', {
            date,
            file: this.qrisFile,
            nama: 'QRIS',
            doc_type: 4,
          })
          .then((response) => {
            if (response.data.success) {
              response.doc_type = '4';
              this.allFile.push(response);
              this.nmid = response.data.data;
            }
          })
          .catch(() => {
            this.qrisFile = null;
          });
      }
    },

    async getApprovalId1(role, username = '', firstLoad = false) {
      this.isLoadingApprovalId1 = true;
      await this.$store
        .dispatch('master/daerah/list/getApprovalId1', {
          date,
          role,
          kodepos: this.namaKodepos,
          search: {
            username,
          },
        })
        .then(() => {
          if (firstLoad) {
            const oldApproval = this.itemsApprovalId1.find(
              (val) => val.username == username
            );
            if (oldApproval == undefined) {
              this.searchApprovalId1 = '';
            }
          }
        })
        .finally(() => {
          this.isLoadingApprovalId1 = false;
        });
    },

    async getApprovalId2(role, username = '', firstLoad = false) {
      this.isLoadingApprovalId2 = true;
      await this.$store
        .dispatch('master/daerah/list/getApprovalId2', {
          date,
          role,
          kodepos: this.namaKodepos,
          search: {
            username,
          },
        })
        .then(() => {
          if (firstLoad) {
            const oldApproval = this.itemsApprovalId2.find(
              (val) => val.username == username
            );
            if (oldApproval == undefined) {
              this.searchApprovalId2 = '';
            }
          }
        })
        .finally(() => {
          this.isLoadingApprovalId2 = false;
        });
    },

    onFocusApprover1() {
      if (!this.approver1Loaded) {
        this.approver1Loaded = true;
        this.getApprovalId1(this.listUserRoles[0].value, '', false);
      }
    },

    onFocusApprover2() {
      if (!this.approver2Loaded) {
        this.approver2Loaded = true;
        this.getApprovalId2(this.listUserRoles[1].value, '', false);
      }
    },

    async save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saveLoading = true;
        
        // Ensure PTEN MDR values are updated before saving
        if (
          this.isEdit &&
          this.isUpdatePTEN &&
          !this.isSpecialMdr &&
          this.jenisUsaha.mcc_id != null &&
          this.jenisUsaha.mcc_id != '' &&
          this.merchantCriteria &&
          this.merchantCriteria.value &&
          !this.loadingPtenMdr
        ) {
          await this.getPtenMdrValues();
        }
        
        const daerah = {
          province_name: this.getNamaDaerah('provinsi', this.kodepos),
          city_name: this.getNamaDaerah('kabupaten', this.kodepos),
          sub_district_name: this.getNamaDaerah('kecamatan', this.kodepos),
          urban_name: this.getNamaDaerah('kelurahan', this.kodepos),
          postal_code: this.getNamaDaerah('kodepos', this.kodepos),
        };
        const daerahOwner = {
          province_name: this.getNamaDaerah('provinsi', this.ownerPostalCode),
          city_name: this.getNamaDaerah('kabupaten', this.ownerPostalCode),
          sub_district_name: this.getNamaDaerah(
            'kecamatan',
            this.ownerPostalCode
          ),
          urban_name: this.getNamaDaerah('kelurahan', this.ownerPostalCode),
          postal_code: this.getNamaDaerah('kodepos', this.ownerPostalCode),
        };
        
        await this.$store
          .dispatch('daftarTugas/rm/updateRMMerchant', {
            date,
            daerah,
            daerahOwner,
            merchant_id: this.$route.params.id,
            tempUniqueData: this.tempUniqueData,
            documents: this.allFile,
            remark: this.remark,
            reason: this.isEditCloseMerchant ? this.reason : this.remarkPTEN,
            endpoint: this.endpoint,
            ipAddress: this.ipAddress,
            channelQr: this.channelQr,
            merchantModel: this.merchantModel,
            qrTypeInterface: this.qrTypeInterface,
            isNeedInterface: this.needInterface,
            isQrTypeWithAPI: this.isQrTypeWithAPI,
            regionalMapping:
              this.isUpdatePTEN
                ? null
                : {
                  bcko: this.bcko?.id || this.bcko?.branch_code_bcko || '',
                  cmer: this.cmer?.id || this.cmer?.code || '',
                  referral_code: this.rmReferalCode || '',
                },
            mdr_file: this.isSpecialMdr ? this.mdrFile : null,
            is_mdr_custom: this.isSpecialMdr,
            mdr_on_us_override: this.useStaticMdrForPten && this.isUpdatePTEN ? this.originalDetailMdrOnUs : null,
            mdr_off_us_override: this.useStaticMdrForPten && this.isUpdatePTEN ? this.originalDetailMdrOffUs : null,
          })
          .then((response) => {
            if (response) {
              this.allFile = [];
              this.$router.push('/daftar-tugas/inputer-list');
              return;
            }

            const qrisUploaded = this.allFile.find((x) => x.doc_type == '4');
            this.allFile = [];
            if (qrisUploaded != undefined) this.allFile.push(qrisUploaded);

            if (this.hasFieldErrors) this.scrollToErrorInput();
          })
          .finally(() => {
            this.saveLoading = false;
          });
      } else {
        this.scrollToErrorInput();
      }
    },

    isEmpty,

    checkKodepos() {
      this.searchKodepos = this.kodepos;
    },

    checkownerPostalCode() {
      this.searchownerPostalCode = this.ownerPostalCode;
    },

    scrollToErrorInput() {
      const keys = Object.keys(this.$v);
      let isError = false;

      keys.forEach((key) => {
        if (key.includes('$')) return;

        if (this.$v[key].$error) {
          const el = document.getElementById(key);
          if (el) {
            this.$vuetify.goTo(el, scrollOptions);
            isError = true;
          }
        }
      });

      if (!isError) this.$vuetify.goTo(0);
    },

    back() {
      this.$router.back();
    },

    async getPtenMdrValues() {
      if (this.loadingPtenMdr) return;
      
      this.loadingPtenMdr = true;
      
      try {
        const mdrResult = await this.$store.dispatch('register/getMdrList', {
          date: this.$store.getters.todayDate,
          mcc: this.jenisUsaha.mcc_id,
          merchant_criteria: this.merchantCriteria.value,
        });
        
        if (mdrResult && mdrResult.mdr_on_us !== undefined && mdrResult.mdr_off_us !== undefined) {
          this.ptenMdrOnUs = parseFloat(mdrResult.mdr_on_us);
          this.ptenMdrOffUs = parseFloat(mdrResult.mdr_off_us);
          
          this.$store.commit('daftarTugas/rm/setMerchantVariable', {
            variable: 'mdr_on_us',
            payload: this.ptenMdrOnUs,
          });
          this.$store.commit('daftarTugas/rm/setMerchantVariable', {
            variable: 'mdr_off_us',
            payload: this.ptenMdrOffUs,
          });
          
          if (this.data) {
            this.data.mdr_on_us = this.ptenMdrOnUs;
            this.data.mdr_off_us = this.ptenMdrOffUs;
          }
          
          this.$nextTick(() => {
            this.mdronus = this.ptenMdrOnUs;
            this.mdroffus = this.ptenMdrOffUs;
          });
        }
      } catch (error) {
        console.error('Error fetching PTEN MDR values:', error);
      } finally {
        this.loadingPtenMdr = false;
      }
    },
  },
};
</script>
<style>
.v-text-field__suffix, 
.mdi-orbit-variant::before {
  color: #e56c26;
}
</style>